import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import * as jquery from 'jquery';
import * as _ from 'underscore';
import { isUndefined, isNullOrUndefined } from '../../models/utils';
import * as XMLWriter from 'xml-writer';
import { SearchDialect } from '../../models/enums';
import { CommonService } from '../common/common.service';
import { isDate } from 'ngx-bootstrap/chronos';

enum AEQueryElements {
    query = 'query',
    dialect = 'dialect',
    DRCLASSIC = 'DRCLASSIC',
    DRSTANDARD = 'DRSTANDARD',
    cookie = 'cookie',
    labeled_clause = '_labeled_clause',
    occur = 'occur',
    SHOULD = 'SHOULD',
    MUST = 'MUST',
    MUST_NOT = 'MUST_NOT',
    field = 'field',
    text = 'text',
    regex = 'regex',
    wildcard = 'wildcard',
    range = 'range',
    type = 'type',
    inclusive = 'inclusive',
    exclusive = 'exclusive',
    inclusive_exclusive = 'inclusive_exclusive',
    exclusive_inclusive = 'exclusive_inclusive',
    begin = 'begin',
    end = 'end',
    fuzzy = 'fuzzy',
    phrase_sloppy = 'phrase_sloppy',
    slop = 'slop',
    phrase_proximity = 'phrase_proximity',
    clause_proximity = 'clause_proximity',
    clause_non_proximity = 'clause_non_proximity',
    distance = 'distance',
    order = 'order',
    ordered = 'ordered',
    unordered = 'unordered',
    parent_of = 'parent_of',
    child_of = 'child_of',
    children_of = 'children_of',
    mag_of = 'mag_of',
    add_mag = 'add_mag',
    dag_of = 'dag_of',
    add_dag = 'add_dag',
    family_of = 'family_of',
    add_family = 'add_family',
    root_of = 'root_of',
    UNDEFINED_ELEMENT = 'UNDEFINED_ELEMENT',
    searchtype = 'searchtype',
    aliasname = 'aliasname',
    archive_of = 'archive_of',
    nested_archive_of = 'nested_archive_of',
    archive_contents = 'archive_contents'
}

enum XmlKeys {
    QueryKey = 'query',
    RangeKey = 'range',
    TypeKey = 'type',
    OccurKey = 'occur',
    CookieKey = 'cookie',
    TextKey = 'text',
    TheseKey = 'These',
    ThoseKey = 'Those',
    OrderKey = 'order',
    DistanceKey = 'distance',
    FieldKey = 'field',
    BeginKey = 'begin',
    EndKey = 'end',
    AliasKey = 'aliasname',
    SearchTypeKey = 'searchtype',
    DialectKey = 'dialect',
    SimpleSearchExpandedKey = 'SimpleSearchExpanded',
    IsFromFreeFormTextKey = 'IsFromFreeFormText',
    ClauseProximityKey = 'clause_proximity',
    LabeledClauseKey = 'labeled_clause',
    KeywordsKey = 'Keywords',
    KeywordsCookieKey = 'DRSimpleSearch_Keywords',
    GAKeywordsCookieKey = 'DRAdvancedSearch_Keywords',
    NumberTypeKey = 'numbertype',

    DateFiltersKey = 'DateFilters',
    DateFiltersCookieKey = 'DRSimpleSearch_DateFilters',  // This seems to be unused
    GADateFiltersCookieKey = 'DRAdvancedSearch_DateFilters',

    DomainFiltersKey = 'DomainFiltersKey',
    AliasFiltersKey = 'AliasFiltersKey',
    FoldersFiltersKey = 'FolderFilters',
    FoldersCookieKey = 'DRSimpleSearch_FolderFilters',
    CustodiansFiltersKey = 'CustodianFilters',
    CustodiansCookieKey = 'DRSimpleSearch_CustodianFilters',
    DomainCookieKey = 'DRSimpleSearch_DomainFilters',
    AliasCookieKey = 'DRSimpleSearch_AliasFilters',
    GADomainCookieKey = 'DRAdvancedSearch_DomainFilters',
    GAAnySenderCookieKey = 'DRAdvancedSearch_Any_Sender',
    GANoneSenderCookieKey = 'DRAdvancedSearch_None_Sender',
    GAAnyReceiverCookieKey = 'DRAdvancedSearch_Any_Receiver',
    GANoneReceiverCookieKey = 'DRAdvancedSearch_None_Receiver',
    GAAliasCookieKey = 'DRAdvancedSearch_AliasFilters',

    TagFiltersKey = 'TagFilters',
    TagCookieKey = 'DRSimpleSearch_TagFilters',
    GATagCookieKey = 'DRAdvancedSearch_TagFilters',
    GAAnyTagCookieKey = 'DRAdvancedSearch_One_Or_More_Of_These_Tags',
    GAAllTagCookieKey = 'DRAdvancedSearch_All_Of_These_Tags',
    GANoneTagCookieKey = 'DRAdvancedSearch_None_Of_These_Tags',

    RecordTypesFiltersKey = 'Record Types',
    RecordTypesCookieKey = 'DRSimpleSearch_RecordTypeFilters',

    AdditionalFiltersKey = 'Additional Properties',
    GAAdditionalCookieKey = 'DRAdvancedSearch_AdditionalFilters',
    GAAnyAdditionalCookieKey = 'DRAdvancedSearch_One_Or_More_Of_These_Additional_Filters',
    GAAllAdditionalCookieKey = 'DRAdvancedSearch_All_Of_These_Additional_Filters',
    GANoneAdditionalCookieKey = 'DRAdvancedSearch_None_Of_These_Additional_Filters',

    DocClassKey = 'docclass',
    FiletypeKey = 'filetype'
}

enum FilterType {
    Keywords,
    Words,
    ExactPhrase,
    WordsWithin,
    Subject,
    SenderRecipient,
    Tag,
    Custodian,
    Folder,
    Date,
    Domain,
    Alias,
    Metadata
}

enum ExistsTag {
    WithoutEscapeChar = '<exists>',
    WithEscapeChar = '&lt;exists&gt;'
}

export class SearchConfig {
    isSimpleSearch = true;
    isSimpleSearchExpanded = false;
    isFromCombinedSearch: boolean;
    simpleParsingNoCookies: boolean;
    searchDialect: string;
    isFromFreeFormQuery: boolean;

    constructor(value?: Partial<SearchConfig>) {
        if (value) {
            if (value.searchDialect === SearchDialect.DR_CLASSIC) {
                value.searchDialect = AEQueryElements.DRCLASSIC;
            } else {
                value.searchDialect = AEQueryElements.DRSTANDARD;
            }
            Object.assign(this, value);
        }
    }
}

export class SearchFilter {
    value = null;
    labeledClause: string;
    occur: string = AEQueryElements.MUST;
    cookie: string;
    filterType: FilterType;
    simpleParsingNoCookies = false;
    isFromCombinedSearch = false;

    constructor(value?: Partial<SearchFilter>) {
        if (value) {
            Object.assign(this, value);
        }
        this.setPropValuesByFilterType();
    }

    setPropValuesByFilterType(): void {
        if (!this.labeledClause) {
            switch (this.filterType) {
                case FilterType.Keywords:
                    this.labeledClause = XmlKeys.KeywordsKey;
                    this.cookie = XmlKeys.GAKeywordsCookieKey;
                    break;
                case FilterType.ExactPhrase:
                    this.labeledClause = 'Exact_Phrase';
                    break;
                case FilterType.WordsWithin:
                    this.labeledClause = 'These_Near_Those';
                    break;
                case FilterType.Subject:
                    this.cookie = 'DRAdvancedSearch_Subject_Filter';
                    break;
                case FilterType.SenderRecipient:
                    this.labeledClause = 'Sender_Recipient_Filter';
                    break;
                case FilterType.Tag:
                    this.labeledClause = XmlKeys.TagFiltersKey;
                    this.cookie = XmlKeys.GATagCookieKey;
                    break;
                case FilterType.Custodian:
                    this.cookie = XmlKeys.CustodiansCookieKey;
                    break;
                case FilterType.Folder:
                    this.cookie = XmlKeys.FoldersCookieKey;
                    break;
                case FilterType.Domain:
                    this.cookie = XmlKeys.GADomainCookieKey;
                    break;
                case FilterType.Alias:
                    this.cookie = XmlKeys.GAAliasCookieKey;
                    break;
                case FilterType.Date:
                    this.labeledClause = XmlKeys.DateFiltersKey;
                    break;
                case FilterType.Metadata:
                    this.labeledClause = XmlKeys.AdditionalFiltersKey;
                    this.cookie = XmlKeys.GAAdditionalCookieKey;
                    break;
            }
        }
        if (!this.cookie && this.labeledClause) {
            this.cookie = (this.isFromCombinedSearch ? 'Combined_Search_' : 'DRAdvancedSearch_') + this.labeledClause;
        }
    }

    writeXmlFromObject(xmlWriter: XMLWriter, isStandardSearch?: boolean): void {
        if (this.value && this.value.trim()) {
            if (this.filterType === FilterType.Keywords) {
                this.writeXmlFromKeywordsObject(xmlWriter);
            } else {
                xmlWriter.startElement(XmlKeys.QueryKey);
                if (this.occur) {
                    xmlWriter.writeAttribute(XmlKeys.OccurKey, this.occur);
                }

                xmlWriter.writeAttribute(XmlKeys.CookieKey, this.cookie);
                if (this.labeledClause) {
                    xmlWriter.writeAttribute(XmlKeys.LabeledClauseKey, this.labeledClause);
                }

                if (this.filterType === FilterType.Words && !this.isFromCombinedSearch) {
                    this.value = this.getWordsList(this.value);
                }
                if (this.value instanceof Array) {
                    this.value.forEach(element => {
                        if (this.filterType === FilterType.Words && this.labeledClause === 'All_Of_These_Words') {
                            this.writeTextWithAttributes(xmlWriter, element, null, this.occur);
                        } else {
                            xmlWriter.writeElement(XmlKeys.TextKey, element);
                        }
                    });
                } else {
                    if (!this.isFromCombinedSearch) {
                        this.value = this.formatQuotedString(this.value);
                    }
                    if (this.filterType === FilterType.Subject) {
                        this.writeTextWithAttributes(xmlWriter, this.value, 'subject');
                    } else {
                        xmlWriter.writeElement(XmlKeys.TextKey, this.value);
                    }
                }
                xmlWriter.endElement();
            }
        }
    }

    writeXmlFromKeywordsObject(xmlWriter: XMLWriter): void {
        if (this.value && this.value.trim()) {
            if (!this.simpleParsingNoCookies) {
                xmlWriter.startElement(XmlKeys.QueryKey);

                if (this.occur) {
                    xmlWriter.writeAttribute(XmlKeys.OccurKey, this.occur);
                }

                xmlWriter.writeAttribute(XmlKeys.CookieKey, this.cookie);
                if (this.labeledClause) {
                    xmlWriter.writeAttribute(XmlKeys.LabeledClauseKey, this.labeledClause);
                }
            }
            xmlWriter.writeElement(XmlKeys.TextKey, this.value);

            xmlWriter.endElement();
        }
    }

    writeTextWithAttributes(xmlWriter: XMLWriter, text: string, field?: string, occur?: string): void {
        xmlWriter.startElement(XmlKeys.TextKey);
        if (occur) {
            xmlWriter.writeAttribute(XmlKeys.OccurKey, occur);
        }
        if (field) {
            xmlWriter.writeAttribute(XmlKeys.FieldKey, field);
        }
        xmlWriter.text(text);
        xmlWriter.endElement();
    }

    formatQuotedString(text: string): string {
        if (text[0] === '"' && text[text.length - 1] === '"') {
            return text;
        } else if (text[0] === '"') {
            text = text.substring(1);
        } else if (text[text.length - 1] === '"') {
            text = text.substring(0, text.length - 1);
        }
        return `"${text}"`;
    }

    getListFromString(data: string): Array<string> {
        if (data && data.trim()) {
            return data.split(' ');
        }
        return null;
    }

    getWordsList(words: string): Array<string> {
        let wordsList = null;
        words = words.trim();
        if (words) {
            wordsList = [];
            const list = words.split('"');

            // no quotes were found
            if (list.length === 1 && list[0] === words) {
                wordsList = words.split(' ');
            } else {  // the string has some quotes inside
                for (let i = 0; i < list.length; i++) {
                    if (i % 2 === 1) {
                        if (list[i].trim() !== '') {
                            wordsList.push('"' + list[i] + '"');
                        }
                    } else {
                        if (list[i].trim() !== '') {
                            Array.prototype.push.apply(wordsList, list[i].trim().split(' '));
                        }
                    }
                }
            }
        }
        wordsList = wordsList.filter(w => w !== '');
        return wordsList;
    }

    getList(words: string): Array<string> {
        const list = [];
        const regEx = /".*?"/g;
        let match;
        do {
            match = regEx.exec(words);
            if (match && match.length > 0) {
                const item = match[0].replace(/\"/g, '');
                if (item) {
                    list.push(item);
                }
            }
        } while (match);
        if (list.length === 0) {
            const itemMatched = words?.replace(/\"/g, '');
            if (itemMatched) {
                list.push(itemMatched);
            }
        }
        return list;
    }

    toObject(queryNode: Element, isStandardSearch: boolean): void {
        if (queryNode) {
            this.value = this.getValueFromElement(queryNode, XmlKeys.TextKey);
        }
    }

    getValueFromElement(queryElement: Element, nodeName: string, attributeName?: string, attributeValue?: string, reverseOccurCheck?: boolean, stripQuotes?: boolean): string {
        const elems = this.getElementsByName(queryElement, nodeName, attributeName, attributeValue, reverseOccurCheck);
        if (elems && elems.length > 0) {
            return elems.map(e => stripQuotes ? e.childNodes[0].nodeValue.replace(/^"(.+(?="$))"$/, '$1') : e.childNodes[0].nodeValue).join(' ');
        }
        return null;
    }

    getElementByName(queryElement: Element, nodeName: string, attributeName?: string, attributeValue?: string, reverseOccurCheck?: boolean): Element {
        const elems = this.getElementsByName(queryElement, nodeName, attributeName, attributeValue, reverseOccurCheck);
        if (elems && elems.length === 1) {
            return elems[0];
        }
        return null;
    }

    getElementsByName(queryElement: Element, nodeName: string, attributeName?: string, attributeValue?: string, reverseOccurCheck?: boolean): Element[] {
        if (queryElement && queryElement.childNodes && queryElement.childNodes.length > 0) {
            let elems = Array.from(queryElement.childNodes).filter(c => c.nodeName === nodeName && c.childNodes && c.childNodes.length > 0);
            if (attributeName && attributeValue) {
                elems = elems.filter(e => reverseOccurCheck ? !this.elementHasAttribute(e as Element, attributeName, attributeValue) :
                    this.elementHasAttribute(e as Element, attributeName, attributeValue));
            }
            if (elems && elems.length > 0) {
                return elems as Element[];
            }
        }
        return [];
    }

    getElementByAttribute(queryElement: Element, attributeName: string, attributeValue: string): Element {
        const elems = this.getElementsByAttribute(queryElement, attributeName, attributeValue);
        if (elems && elems.length > 0) {
            return elems[0];
        }
        return null;
    }

    getElementsByAttribute(queryElement: Element, attributeName: string, attributeValue: string): Element[] {
        if (queryElement && queryElement.childNodes && queryElement.childNodes.length > 0) {
            const elems = Array.from(queryElement.childNodes).filter(c => this.elementHasAttribute(c as Element, attributeName, attributeValue));
            if (elems && elems.length > 0) {
                return elems as Element[];
            }
        }
        return null;
    }

    elementHasAttribute(queryElement: Element, attributeName: string, attributeValue: string): boolean {
        return attributeValue && this.getElementAttribute(queryElement, attributeName) === attributeValue;
    }

    getElementAttribute(queryElement: Element, attributeName: string): string {
        if (queryElement && queryElement.attributes.getNamedItem(attributeName)) {
            return queryElement.attributes.getNamedItem(attributeName).value;
        }
        return null;
    }

    getDateFromString(stringDate: string): Date {
        let date: Date = null;
        if (stringDate && stringDate.trim() !== '' && stringDate !== '0000-00-00-00-00-00' && stringDate !== '9999-12-31-23-59-59') {
            const tokens = stringDate.split('-');
            if (tokens && tokens.length === 6) {
                const tokenNumbers = tokens.map(t => parseInt(t, 10));
                date = new Date(tokenNumbers[0], tokenNumbers[1] - 1, tokenNumbers[2], tokenNumbers[3], tokenNumbers[4], tokenNumbers[5]);
            }
        }
        return date;
    }
}

export class WordsWithin extends SearchFilter {
    these = null;
    those = null;
    distance = null;

    constructor(value?: Partial<WordsWithin>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }

    writeXmlFromObject(xmlWriter: XMLWriter, isStandardSearch: boolean): void {
        if (this.these && this.these.trim() && this.those && this.those.trim() && this.distance) {
            this.these = this.getWordsList(this.these);
            this.those = this.getWordsList(this.those);
            if (this.these.length > 0 && this.those.length > 0) {
                xmlWriter.startElement(XmlKeys.QueryKey);
                xmlWriter.writeAttribute(XmlKeys.OccurKey, this.occur);
                xmlWriter.writeAttribute(XmlKeys.CookieKey, this.cookie);
                xmlWriter.writeAttribute(XmlKeys.LabeledClauseKey, this.labeledClause);

                xmlWriter.startElement(XmlKeys.ClauseProximityKey);
                xmlWriter.writeAttribute(XmlKeys.OrderKey, 'unordered');
                if (isStandardSearch) {
                    const dist = parseInt(this.distance, 10);
                    this.distance = isNaN(dist) ? 0 : dist - 1;
                }
                xmlWriter.writeAttribute(XmlKeys.DistanceKey, this.distance);

                xmlWriter.startElement(XmlKeys.QueryKey);
                // these
                xmlWriter.startElement(XmlKeys.QueryKey);
                xmlWriter.writeAttribute(XmlKeys.CookieKey, XmlKeys.TheseKey);
                this.these.forEach(item => {
                    if (item) {
                        xmlWriter.writeElement(XmlKeys.TextKey, item);
                    }
                });
                xmlWriter.endElement(); // these

                // those
                xmlWriter.startElement(XmlKeys.QueryKey);
                xmlWriter.writeAttribute(XmlKeys.CookieKey, XmlKeys.ThoseKey);
                this.those.forEach(item => {
                    if (item) {
                        xmlWriter.writeElement(XmlKeys.TextKey, item);
                    }
                });
                xmlWriter.endElement(); // those

                xmlWriter.endElement(); // query
                xmlWriter.endElement(); // clause
                xmlWriter.endElement(); // query
            }
        }
    }

    toObject(queryNode: Element, isStandardSearch: boolean): void {
        if (queryNode) {
            queryNode = this.getElementByName(queryNode, XmlKeys.ClauseProximityKey);
            if (queryNode) {
                if (queryNode.attributes) {
                    const distance = queryNode.attributes.getNamedItem(XmlKeys.DistanceKey);
                    if (distance && distance.value) {
                        const dist = parseInt(distance.value, 10);
                        this.distance = isNaN(dist) ? 10 : dist;
                        if (isStandardSearch) {
                            this.distance++;
                        }
                    }
                }
                queryNode = this.getElementByName(queryNode, XmlKeys.QueryKey);
                if (queryNode) {
                    const these = this.getElementByAttribute(queryNode, XmlKeys.CookieKey, XmlKeys.TheseKey);
                    if (these) {
                        this.these = this.getValueFromElement(these, XmlKeys.TextKey);
                    }
                    const those = this.getElementByAttribute(queryNode, XmlKeys.CookieKey, XmlKeys.ThoseKey);
                    if (those) {
                        this.those = this.getValueFromElement(those, XmlKeys.TextKey);
                    }
                }
            }
        }
    }
}

export class TagsFilter extends SearchFilter {
    anyTags = null;
    allTags = null;
    noneTags = null;

    writeXmlFromObject(xmlWriter: XMLWriter): void {
        if ((this.anyTags && this.anyTags.trim()) || (this.allTags && this.allTags.trim()) || (this.noneTags && this.noneTags.trim())) {
            xmlWriter.startElement(XmlKeys.QueryKey);

            xmlWriter.writeAttribute(XmlKeys.OccurKey, this.occur);
            xmlWriter.writeAttribute(XmlKeys.CookieKey, this.cookie);

            this.anyTags = this.getList(this.anyTags);
            if (this.anyTags.length > 0) {
                xmlWriter.startElement(XmlKeys.QueryKey);
                xmlWriter.writeAttribute(XmlKeys.OccurKey, this.occur);
                xmlWriter.writeAttribute(XmlKeys.CookieKey, XmlKeys.GAAnyTagCookieKey);

                this.anyTags.forEach(item => {
                    if (item) {
                        item = this.formatQuotedString(item);
                        this.writeTextWithAttributes(xmlWriter, item, 'tag_view');
                    }
                });
                xmlWriter.endElement();
            }
            this.allTags = this.getList(this.allTags);
            if (this.allTags.length > 0) {
                xmlWriter.startElement(XmlKeys.QueryKey);
                xmlWriter.writeAttribute(XmlKeys.OccurKey, this.occur);
                xmlWriter.writeAttribute(XmlKeys.CookieKey, XmlKeys.GAAllTagCookieKey);

                this.allTags.forEach(item => {
                    if (item) {
                        item = this.formatQuotedString(item);
                        this.writeTextWithAttributes(xmlWriter, item, 'tag_view', this.occur);
                    }
                });
                xmlWriter.endElement();
            }
            this.noneTags = this.getList(this.noneTags);
            if (this.noneTags.length > 0) {
                xmlWriter.startElement(XmlKeys.QueryKey);
                xmlWriter.writeAttribute(XmlKeys.OccurKey, this.occur);
                xmlWriter.writeAttribute(XmlKeys.CookieKey, XmlKeys.GANoneTagCookieKey);

                xmlWriter.startElement(XmlKeys.QueryKey);
                xmlWriter.writeAttribute(XmlKeys.OccurKey, AEQueryElements.MUST_NOT);

                this.noneTags.forEach(item => {
                    if (item) {
                        item = this.formatQuotedString(item);
                        this.writeTextWithAttributes(xmlWriter, item, 'tag_view');
                    }
                });
                xmlWriter.endElement();
                xmlWriter.endElement();
            }
            xmlWriter.endElement();
        }
    }

    toObject(queryNode: Element, isStandardSearch: boolean): void {
        if (queryNode) {
            const anyTags = this.getElementByAttribute(queryNode, XmlKeys.CookieKey, XmlKeys.GAAnyTagCookieKey);
            if (anyTags) {
                this.anyTags = this.getValueFromElement(anyTags, XmlKeys.TextKey);
            }
            const allTags = this.getElementByAttribute(queryNode, XmlKeys.CookieKey, XmlKeys.GAAllTagCookieKey);
            if (allTags) {
                this.allTags = this.getValueFromElement(allTags, XmlKeys.TextKey);
            }
            let noneTags = this.getElementByAttribute(queryNode, XmlKeys.CookieKey, XmlKeys.GANoneTagCookieKey);
            if (noneTags) {
                noneTags = this.getElementByName(noneTags, XmlKeys.QueryKey);
                if (noneTags) {
                    this.noneTags = this.getValueFromElement(noneTags, XmlKeys.TextKey);
                }
            }
        }
    }
}

export class EntityFilter extends SearchFilter {
    anyItems = null;
    noneItems = null;

    constructor(value?: Partial<EntityFilter>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }

    writeXmlFromObject(xmlWriter: XMLWriter): void {
        if ((this.anyItems && this.anyItems.trim()) || (this.noneItems && this.noneItems.trim())) {
            xmlWriter.startElement(XmlKeys.QueryKey);

            xmlWriter.writeAttribute(XmlKeys.OccurKey, this.occur);
            xmlWriter.writeAttribute(XmlKeys.CookieKey, this.cookie);

            const fieldValue = this.filterType === FilterType.Custodian ? 'custodian_view' : 'group_view';
            this.anyItems = this.getList(this.anyItems);
            if (this.anyItems.length > 0) {
                this.anyItems.forEach(item => {
                    if (item) {
                        this.writeTextWithAttributes(xmlWriter, '\"' + item.replace(/\"/g, '') + '\"', fieldValue);
                    }
                });
            }
            this.noneItems = this.getList(this.noneItems);
            if (this.noneItems.length > 0) {
                this.noneItems.forEach(item => {
                    if (item) {
                        this.writeTextWithAttributes(xmlWriter, '\"' + item.replace(/\"/g, '') + '\"', fieldValue, AEQueryElements.MUST_NOT);
                    }
                });
            }

            xmlWriter.endElement();
        }
    }

    toObject(queryNode: Element, isStandardSearch: boolean): void {
        if (queryNode) {
            this.anyItems = this.getValueFromElement(queryNode, XmlKeys.TextKey, XmlKeys.OccurKey, AEQueryElements.MUST_NOT, true);
            this.noneItems = this.getValueFromElement(queryNode, XmlKeys.TextKey, XmlKeys.OccurKey, AEQueryElements.MUST_NOT);
        }
    }
}

export class AliasFilter extends SearchFilter {
    noneSenderAliases = null;
    someSenderAliases = null;
    noneOfAliasesInContent = null;
    someOfAliasesInContent = null;
    someRecipientAliases = null;
    noneRecipientAliases = null;
    aliasListForSearch = null;

    constructor(value?: Partial<AliasFilter>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }

    wrapAlias(xmlWriter: XMLWriter, xmlFn: () => void, createWrapper: boolean, occurByOp?: string): void {
        occurByOp = occurByOp || this.occur;
        if (createWrapper) {
            xmlWriter.startElement(XmlKeys.QueryKey);
            xmlWriter.writeAttribute(XmlKeys.OccurKey, occurByOp);
            xmlWriter.writeAttribute(XmlKeys.CookieKey, this.cookie);
        }
        xmlFn();
        if (createWrapper) {
            xmlWriter.endElement();
        }
    }

    writeXmlFromObject(xmlWriter: XMLWriter): void {
        const typeCount = _.filter([this.noneSenderAliases, this.someSenderAliases, this.noneOfAliasesInContent, this.someOfAliasesInContent, this.someRecipientAliases, this.noneRecipientAliases],
            (type) => type).length;
        if (typeCount > 0) {
            xmlWriter.startElement(XmlKeys.QueryKey);

            xmlWriter.writeAttribute(XmlKeys.OccurKey, this.occur);
            xmlWriter.writeAttribute(XmlKeys.CookieKey, this.cookie);

            if (this.someSenderAliases) {
                this.wrapAlias(xmlWriter, function () { this.getSendersXml(xmlWriter, this.someSenderAliases); }.bind(this), typeCount > 1);
            }
            if (this.noneSenderAliases) {
                this.wrapAlias(xmlWriter, function () { this.getSendersXml(xmlWriter, this.noneSenderAliases, AEQueryElements.MUST_NOT); }.bind(this), typeCount > 1);
            }
            if (this.someOfAliasesInContent) {
                this.wrapAlias(xmlWriter, function () { this.getRecipientXml(xmlWriter, this.someOfAliasesInContent); }.bind(this), typeCount > 1);
            }
            if (this.noneOfAliasesInContent) {
                this.wrapAlias(xmlWriter, function () { this.getSendersXml(xmlWriter, this.noneOfAliasesInContent, AEQueryElements.MUST_NOT, true); }.bind(this), typeCount > 1);
            }
            if (this.someRecipientAliases) {
                this.wrapAlias(xmlWriter, function () { this.getSendersXml(xmlWriter, this.someRecipientAliases, AEQueryElements.SHOULD, true); }.bind(this), typeCount > 1);
            }
            if (this.noneRecipientAliases) {
                this.wrapAlias(xmlWriter, function () { this.getRecipientXml(xmlWriter, this.noneRecipientAliases, AEQueryElements.MUST_NOT); }.bind(this), typeCount > 1);
            }
            xmlWriter.endElement();
        }
    }

    getSendersXml(xmlWriter: XMLWriter, list: string, occur?: string, inContent = false): void {
        let allListValues = [];
        allListValues = this.getList(list);
        if (allListValues.length > 0) {
            allListValues.forEach(item => {
                if (item && this.aliasListForSearch) {
                    const rez = this.aliasListForSearch.find(a => a.name === item);
                    const name = rez?.name;
                    if (name) {
                        if (!inContent) {
                            this.writeTextElement(xmlWriter, 'from', item, name, occur, inContent);
                            this.writeTextElement(xmlWriter, 'altfrom', item, name, occur, inContent);
                            this.writeTextElement(xmlWriter, 'sender', item, name, occur, inContent);
                            this.writeTextElement(xmlWriter, 'altsender', item, name, occur, inContent);
                        } else {
                            this.writeTextElement(xmlWriter, 'contents', item, name, occur, inContent);
                        }
                    }
                }
            });
        }
    }

    getRecipientXml(xmlWriter: XMLWriter, list: string, occur?: string): void {
        let allListValues = [];
        allListValues = this.getList(list);
        if (allListValues.length > 0) {
            allListValues.forEach(item => {
                if (item && this.aliasListForSearch) {
                    const name = this.aliasListForSearch.find(a => a.name === item)?.name;
                    if (name) {
                        this.writeTextElement(xmlWriter, 'to', item, name, occur);
                        this.writeTextElement(xmlWriter, 'altto', item, name, occur);
                        this.writeTextElement(xmlWriter, 'cc', item, name, occur);
                        this.writeTextElement(xmlWriter, 'altcc', item, name, occur);
                        this.writeTextElement(xmlWriter, 'bcc', item, name, occur);
                        this.writeTextElement(xmlWriter, 'altbcc', item, name, occur);
                    }
                }
            });
        }
    }

    writeTextElement(xmlWriter: XMLWriter, field: string, alias: string, text: string, occur: string, inContent = false): void {
        xmlWriter.startElement(XmlKeys.TextKey);
        if (occur) {
            xmlWriter.writeAttribute(XmlKeys.OccurKey, occur);
        }
        if (!inContent) {
            xmlWriter.writeAttribute(XmlKeys.FieldKey, field);
        } else {
            const keyName = (occur && occur === AEQueryElements.MUST_NOT) ? 'nonealiases' : 'somealiases';
            xmlWriter.writeAttribute(XmlKeys.SearchTypeKey, keyName);
            xmlWriter.writeAttribute(XmlKeys.FieldKey, field);
        }
        xmlWriter.writeAttribute(XmlKeys.AliasKey, alias);
        xmlWriter.text(text.replace(/\"/g, ''));
        xmlWriter.endElement();
    }

    toObject(queryNode: HTMLElement, isStandardSearch: boolean): void {
        if (queryNode) {
            let isQueryList = false;
            let textNodes = this.getElementsByName(queryNode, XmlKeys.TextKey);
            if (textNodes && textNodes.length === 0) {
                textNodes = this.getElementsByName(queryNode, XmlKeys.QueryKey);
                isQueryList = true;
            }

            if (textNodes && textNodes.length > 0) {
                if (isQueryList) {
                    textNodes.forEach(node => {
                        this.getTextNodeData(node.childNodes);
                    });
                } else {
                    this.getTextNodeData(textNodes);
                }
            }
            if (this.noneSenderAliases) {
                this.noneSenderAliases = this.noneSenderAliases.map(a => `"${a}"`).join(' ');
            }
            if (this.someSenderAliases) {
                this.someSenderAliases = this.someSenderAliases.map(a => `"${a}"`).join(' ');
            }
            if (this.noneRecipientAliases) {
                this.noneRecipientAliases = this.noneRecipientAliases.map(a => `"${a}"`).join(' ');
            }
            if (this.someRecipientAliases) {
                this.someRecipientAliases = this.someRecipientAliases.map(a => `"${a}"`).join(' ');
            }
            if (this.someOfAliasesInContent) {
                this.someOfAliasesInContent = this.someOfAliasesInContent.map(a => `"${a}"`).join(' ');
            }
            if (this.noneOfAliasesInContent) {
                this.noneOfAliasesInContent = this.noneOfAliasesInContent.map(a => `"${a}"`).join(' ');
            }
        }
    }

    getTextNodeData(textNodes: any): void { // leaving this all as it is as it is causing issues with line: 782 or this.getTextNodeData(node.childNodes); in toObject method as the type is unknown
        textNodes.forEach(textNode => {
            let list: Array<string> = null;
            const occur = this.getElementAttribute(textNode, XmlKeys.OccurKey);
            let field = this.getElementAttribute(textNode, XmlKeys.FieldKey);
            if (!field || field === 'contents') {
                field = this.getElementAttribute(textNode, XmlKeys.SearchTypeKey);
            }
            const aliasname = this.getElementAttribute(textNode, XmlKeys.AliasKey);
            if (field && aliasname) {
                switch (field) {
                    case 'from':
                        if (occur === AEQueryElements.MUST_NOT) {
                            if (!this.noneSenderAliases) { this.noneSenderAliases = new Array<string>(); }
                            list = this.noneSenderAliases;
                        } else {
                            if (!this.someSenderAliases) { this.someSenderAliases = new Array<string>(); }
                            list = this.someSenderAliases;
                        }
                        break;
                    case 'to':
                        if (occur === AEQueryElements.MUST_NOT) {
                            if (!this.noneRecipientAliases) { this.noneRecipientAliases = new Array<string>(); }
                            list = this.noneRecipientAliases;
                        } else {
                            if (!this.someRecipientAliases) { this.someRecipientAliases = new Array<string>(); }
                            list = this.someRecipientAliases;
                        }
                        break;
                    case 'somealiases':
                        if (!this.someOfAliasesInContent) { this.someOfAliasesInContent = new Array<string>(); }
                        list = this.someOfAliasesInContent;
                        break;
                    case 'nonealiases':
                        if (!this.noneOfAliasesInContent) { this.noneOfAliasesInContent = new Array<string>(); }
                        list = this.noneOfAliasesInContent;
                        break;
                }
                if (list && !list.includes(aliasname)) {
                    list.push(aliasname);
                }
            }
        });
    }
}

export class Sender extends SearchFilter {
    isRecipient = false;
    peoples = null;

    constructor(value?: Partial<Sender>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
        this.cookie = this.isRecipient ? 'DRAdvancedSearch_Recipient_Filter' : 'DRAdvancedSearch_Sender_Filter';
    }

    writeXmlFromObject(xmlWriter: XMLWriter): void {
        this.peoples = this.getWordsList(this.peoples);
        if (this.peoples) {
            xmlWriter.startElement(XmlKeys.QueryKey);

            xmlWriter.writeAttribute(XmlKeys.OccurKey, this.occur);
            xmlWriter.writeAttribute(XmlKeys.CookieKey, this.cookie);

            this.peoples.forEach(item => {
                if (item) {
                    item = this.formatQuotedString(item);
                    if (this.isRecipient) {
                        this.writeTextWithAttributes(xmlWriter, item, 'to');
                        this.writeTextWithAttributes(xmlWriter, item, 'cc');
                        this.writeTextWithAttributes(xmlWriter, item, 'bcc');
                    } else {
                        this.writeTextWithAttributes(xmlWriter, item, 'from');
                        this.writeTextWithAttributes(xmlWriter, item, 'sender');
                    }
                }
            });

            xmlWriter.endElement();
        }
    }
}

export class SenderRecipient extends SearchFilter {
    senders = new Sender();
    recipients = new Sender({ isRecipient: true });
    operation = 'and';

    constructor(value?: Partial<SenderRecipient>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }

    writeXmlFromObject(xmlWriter: XMLWriter): void {
        if ((this.senders.peoples && this.senders.peoples.trim()) || (this.recipients.peoples && this.recipients.peoples.trim())) {
            xmlWriter.startElement(XmlKeys.QueryKey);

            xmlWriter.writeAttribute(XmlKeys.OccurKey, this.occur);
            xmlWriter.writeAttribute(XmlKeys.CookieKey, this.cookie);

            const occurByOp = this.operation === 'and' ? AEQueryElements.MUST : AEQueryElements.SHOULD;

            if (this.senders.peoples) {
                this.senders.occur = occurByOp;
                this.senders.writeXmlFromObject(xmlWriter);
            }
            if (this.recipients.peoples) {
                this.recipients.occur = occurByOp;
                this.recipients.writeXmlFromObject(xmlWriter);
            }
            xmlWriter.endElement();
        }
    }

    toObject(queryNode: Element, isStandardSearch: boolean): void {
        if (queryNode) {
            const senders = this.getElementByAttribute(queryNode, XmlKeys.CookieKey, 'DRAdvancedSearch_Sender_Filter');
            if (senders) {
                const occur = this.getElementAttribute(senders, XmlKeys.OccurKey);
                this.operation = occur === AEQueryElements.MUST ? 'and' : 'or';
                this.senders.occur = occur;
                this.senders.peoples = this.getValueFromElement(senders, XmlKeys.TextKey, XmlKeys.FieldKey, 'from');
            }
            const recipients = this.getElementByAttribute(queryNode, XmlKeys.CookieKey, 'DRAdvancedSearch_Recipient_Filter');
            if (recipients) {
                const occur = this.getElementAttribute(recipients, XmlKeys.OccurKey);
                this.operation = occur === AEQueryElements.MUST ? 'and' : 'or';
                this.recipients.occur = occur;
                this.recipients.peoples = this.getValueFromElement(recipients, XmlKeys.TextKey, XmlKeys.FieldKey, 'to');
            }
        }
    }
}

export class DomainsFilter extends SearchFilter {
    senderDomains = null;
    senderDomainsNone = null;
    receiverDomains = null;
    receiverDomainsNone = null;
    recipientDomainsOperation = 'and';

    constructor(value?: Partial<Sender>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }

    writeXmlFromObject(xmlWriter: XMLWriter): void {
        if (this.senderDomains?.trim() || this.senderDomainsNone?.trim() || this.receiverDomains?.trim() || this.receiverDomainsNone?.trim()) {
            xmlWriter.startElement(XmlKeys.QueryKey);

            xmlWriter.writeAttribute(XmlKeys.OccurKey, this.occur);
            xmlWriter.writeAttribute(XmlKeys.CookieKey, this.cookie);

            if (this.senderDomains) {
                this.senderDomains = this.getWordsList(this.senderDomains);
                xmlWriter.startElement(XmlKeys.QueryKey);
                xmlWriter.writeAttribute(XmlKeys.OccurKey, this.occur);
                xmlWriter.writeAttribute(XmlKeys.CookieKey, XmlKeys.GAAnySenderCookieKey);
                this.senderDomains.forEach(item => {
                    if (item) {
                        this.writeTextWithAttributes(xmlWriter, item, 'sentdomains');
                    }
                });
                xmlWriter.endElement();
            }
            if (this.senderDomainsNone) {
                xmlWriter.startElement(XmlKeys.QueryKey);
                xmlWriter.writeAttribute(XmlKeys.OccurKey, this.occur);
                xmlWriter.writeAttribute(XmlKeys.CookieKey, XmlKeys.GANoneSenderCookieKey);

                this.senderDomainsNone = this.getWordsList(this.senderDomainsNone);
                this.senderDomainsNone.forEach(item => {
                    if (item) {
                        this.writeTextWithAttributes(xmlWriter, item, 'sentdomains', AEQueryElements.MUST_NOT);
                    }
                });
                xmlWriter.endElement();
            }
            if (this.receiverDomains) {
                const occurByOp = this.recipientDomainsOperation === 'and' ? AEQueryElements.MUST : AEQueryElements.SHOULD;
                this.receiverDomains = this.getWordsList(this.receiverDomains);
                xmlWriter.startElement(XmlKeys.QueryKey);
                xmlWriter.writeAttribute(XmlKeys.OccurKey, occurByOp);
                xmlWriter.writeAttribute(XmlKeys.CookieKey, XmlKeys.GAAnyReceiverCookieKey);
                this.receiverDomains.forEach(item => {
                    if (item) {
                        this.writeTextWithAttributes(xmlWriter, item, 'rcvddomains');
                    }
                });
                xmlWriter.endElement();
            }
            if (this.receiverDomainsNone) {
                this.receiverDomainsNone = this.getWordsList(this.receiverDomainsNone);
                xmlWriter.startElement(XmlKeys.QueryKey);
                xmlWriter.writeAttribute(XmlKeys.OccurKey, this.occur);
                xmlWriter.writeAttribute(XmlKeys.CookieKey, XmlKeys.GANoneReceiverCookieKey);
                this.receiverDomainsNone.forEach(item => {
                    if (item) {
                        this.writeTextWithAttributes(xmlWriter, item, 'rcvddomains', AEQueryElements.MUST_NOT);
                    }
                });
                xmlWriter.endElement();
            }
            xmlWriter.endElement();
        }
    }

    toObject(queryNode: Element, isStandardSearch: boolean): void {
        if (queryNode) {
            const anySenders = this.getElementByAttribute(queryNode, XmlKeys.CookieKey, XmlKeys.GAAnySenderCookieKey);
            if (anySenders) {
                this.senderDomains = this.getValueFromElement(anySenders, XmlKeys.TextKey);
            }
            const anyReceivers = this.getElementByAttribute(queryNode, XmlKeys.CookieKey, XmlKeys.GAAnyReceiverCookieKey);
            if (anyReceivers) {
                this.receiverDomains = this.getValueFromElement(anyReceivers, XmlKeys.TextKey);
                // Restore recipientDomainsOperation from the occur attribute
                const occurAttr = anyReceivers.getAttribute(XmlKeys.OccurKey);
                if (occurAttr) {
                    this.recipientDomainsOperation = occurAttr === AEQueryElements.MUST ? 'and' : 'or';
                }
            }
            const anySendersNone = this.getElementByAttribute(queryNode, XmlKeys.CookieKey, XmlKeys.GANoneSenderCookieKey);
            if (anySendersNone) {
                this.senderDomainsNone = this.getValueFromElement(anySendersNone, XmlKeys.TextKey);
            }
            const anyReceiversNone = this.getElementByAttribute(queryNode, XmlKeys.CookieKey, XmlKeys.GANoneReceiverCookieKey);
            if (anyReceiversNone) {
                this.receiverDomainsNone = this.getValueFromElement(anyReceiversNone, XmlKeys.TextKey);
            }
        }
    }
}

export class DateFilter extends SearchFilter {
    beginDate: Date = null;
    beginValue: string = null;
    endDate: Date = null;
    endValue: string = null;

    flags = {
        sent: false, received: false,
        datestarted: false, dateended: false,
        dateaccessed: false, datecreated: false, datemodified: false,
        lastaccesstime: false, createdtime: false, lastmodifiedtime: false
    };

    settings = {
        dateRangeType: '', // posible values: all, parent, custom
        includeParentEmails: false,
        useEmailCreatedDate: false,
        searchTermsType: '', // posible values: family, document
        expandDateRange: false
    };

    isStandardSearch = false;

    constructor(value?: Partial<DateFilter>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }

    writeXmlFromObject(xmlWriter: XMLWriter, isStandardSearch: boolean): void {
        this.isStandardSearch = isStandardSearch;
        if (this.settings.dateRangeType && (this.beginDate || this.endDate)
            && (this.flags.sent || this.flags.received || this.flags.datestarted || this.flags.dateended || this.flags.lastmodifiedtime || this.flags.lastaccesstime || this.flags.createdtime
                || this.flags.dateaccessed || this.flags.datecreated || this.flags.datemodified)) {
            this.getDateValues();
            xmlWriter.startElement(XmlKeys.QueryKey);
            xmlWriter.writeAttribute(XmlKeys.OccurKey, this.occur);
            xmlWriter.writeAttribute(XmlKeys.CookieKey, this.cookie);
            xmlWriter.writeAttribute(XmlKeys.LabeledClauseKey, this.labeledClause);

            const props = Object.keys(this.settings);
            props.forEach(prop => {
                xmlWriter.writeAttribute(prop, this.settings[prop].toString());
            });

            let query = this.settings.searchTermsType === 'family' ? 'family_of(' : '';

            const shouldOccur = this.getOccurString(AEQueryElements.SHOULD);
            const mustOccur = this.getOccurString(AEQueryElements.MUST);
            const mustNotOccur = this.getOccurString(AEQueryElements.MUST_NOT);
            const notOccur = this.getOccurString(AEQueryElements.MUST_NOT, true);
            switch (this.settings.dateRangeType) {
                case 'allDates': {
                    query += '(' + this.getRangeString('sent') + shouldOccur +
                        this.getRangeString('received') + shouldOccur + this.getRangeString('datestarted') + ')';
                    query += shouldOccur + '((' + this.getRangeString('datemodified') +
                        shouldOccur + '(' + notOccur + this.getRangeString('datemodified', '<exists>') +
                        mustOccur + this.getRangeString('datecreated') + ')' +
                        shouldOccur + '(' + notOccur + this.getRangeString('datemodified', '<exists>') +
                        mustNotOccur + this.getRangeString('datecreated', '<exists>') +
                        mustOccur + this.getRangeString('lastmodifiedtime') + ')' +
                        shouldOccur + '(' + notOccur + this.getRangeString('datemodified', '<exists>') +
                        mustNotOccur + this.getRangeString('datecreated', '<exists>') +
                        mustNotOccur + this.getRangeString('lastmodifiedtime', '<exists>') +
                        mustOccur + this.getRangeString('createdtime') + '))' +
                        mustOccur + '(' + this.getRangeString('docclass', 'EDoc') +
                        shouldOccur + '((' + this.getRangeString('docclass', 'EDoc_OLE_Attachment') +
                        shouldOccur + this.getRangeString('docclass', 'Message_Attachment') +
                        shouldOccur + this.getRangeString('docclass', 'Message_OLE_Attachment') + ')' +
                        mustNotOccur + this.getRangeString('filetype', 'email') +
                        mustNotOccur + this.getRangeString('filetype', 'MS Outlook') +
                        mustNotOccur + this.getRangeString('filetype', 'vCalendar') + ')))';
                    break;
                }
                case 'parentDates': {
                    query += '((' + this.getRangeString('sent') +
                        shouldOccur + this.getRangeString('received') + shouldOccur + this.getRangeString('datestarted') + ')' +
                        mustOccur + this.getRangeString('docclass', 'Message') + ')';
                    query += shouldOccur + '((' + this.getRangeString('datemodified') +
                        shouldOccur + '(' + notOccur + this.getRangeString('datemodified', '<exists>') +
                        mustOccur + this.getRangeString('datecreated') + ')' +
                        shouldOccur + '(' + notOccur + this.getRangeString('datemodified', '<exists>') +
                        mustNotOccur + this.getRangeString('datecreated', '<exists>') +
                        mustOccur + this.getRangeString('lastmodifiedtime') + ')' +
                        shouldOccur + '(' + notOccur + this.getRangeString('datemodified', '<exists>') +
                        mustNotOccur + this.getRangeString('datecreated', '<exists>') +
                        mustNotOccur + this.getRangeString('lastmodifiedtime', '<exists>') +
                        mustOccur + this.getRangeString('createdtime') + '))' +
                        mustOccur + this.getRangeString('docclass', 'EDoc') + ')';
                    break;
                }
                case 'customDates': {
                    query += '(';
                    const flagProps = Object.keys(this.flags);

                    flagProps.forEach(prop => {
                        if (this.flags[prop] === true) {
                            if (query[query.length - 1] !== '(') {
                                // not first item, add occur
                                query += shouldOccur;
                            }
                            query += this.getRangeString(prop);
                        }
                    });
                    query += ')';
                    break;
                }
            }
            if (this.settings.includeParentEmails) {
                if (this.settings.useEmailCreatedDate) {
                    query += shouldOccur + '((' + notOccur + this.getRangeString('sent', '<exists>') +
                        mustNotOccur + this.getRangeString('received', '<exists>') +
                        mustNotOccur + this.getRangeString('datestarted', '<exists>') +
                        mustOccur + this.getRangeString('datecreated') +
                        mustNotOccur + this.getRangeString('msgclass', 'contact') +
                        mustNotOccur + this.getRangeString('msgclass', 'distlist') +
                        mustNotOccur + this.getRangeString('msgclass', 'journal') +
                        mustNotOccur + this.getRangeString('msgclass', 'note') +
                        mustNotOccur + this.getRangeString('msgclass', 'todo') + ')' +
                        mustOccur + this.getRangeString('docclass', 'Message') + ')';
                } else {
                    query += shouldOccur + '((' + notOccur + this.getRangeString('sent', '<exists>') +
                        mustNotOccur + this.getRangeString('received', '<exists>') +
                        mustNotOccur + this.getRangeString('datestarted', '<exists>') +
                        mustNotOccur + this.getRangeString('msgclass', 'contact') +
                        mustNotOccur + this.getRangeString('msgclass', 'distlist') +
                        mustNotOccur + this.getRangeString('msgclass', 'journal') +
                        mustNotOccur + this.getRangeString('msgclass', 'note') +
                        mustNotOccur + this.getRangeString('msgclass', 'todo') + ')' +
                        mustOccur + this.getRangeString('docclass', 'Message') + ')';
                }
            }

            query += this.settings.searchTermsType === 'family' ? ')' : '';
            // query = query.replace(/</g, '&lt;').replace(/>/g, '&gt;');
            xmlWriter.writeElement(XmlKeys.TextKey, query);

            xmlWriter.endElement();
        }
    }

    getDateValues(): void {
        if (!this.beginDate) {
            this.beginValue = '0000-00-00-00-00-00';
        } else {
            this.beginValue = new DatePipe('en-US').transform(this.beginDate, 'yyyy-MM-dd') + '-00-00-00';
        }
        if (!this.endDate) {
            this.endValue = '9999-12-31-23-59-59';
        } else {
            this.endValue = new DatePipe('en-US').transform(this.endDate, 'yyyy-MM-dd-23-59-59');
        }
    }

    getRangeString(field: string, customValue?: string): string {
        return field + this.getEqualityString() + (customValue ? customValue : ('[' + this.beginValue + (this.isStandardSearch ? ' ~~ ' : ' TO ') + this.endValue + ']'));
    }

    getOccurString(occur: string, isFirst?: boolean): string {
        if (occur === AEQueryElements.MUST_NOT) {
            return (this.isStandardSearch ? (isFirst ? 'NOT ' : ' AND NOT ') : ' -');
        } else if (occur === AEQueryElements.MUST) {
            return (this.isStandardSearch ? ' AND ' : ' +');
        } else {
            return (this.isStandardSearch ? ' OR ' : ' ');
        }
    }

    getEqualityString(): string {
        return (this.isStandardSearch ? '::' : ':');
    }

    toObject(queryNode: Element, isStandardSearch: boolean): void {
        if (queryNode) {
            this.isStandardSearch = isStandardSearch;
            const textNode = this.getElementByName(queryNode, XmlKeys.TextKey);
            if (textNode) {
                const textValue = textNode.textContent;

                const matches = textValue.match(/\[(.*?)\]/);
                if (matches) {
                    const submatch = matches[1];
                    const dates = submatch.split(' ~~ ');
                    if (dates.length === 2) {
                        this.beginDate = this.getDateFromString(dates[0]);
                        this.endDate = this.getDateFromString(dates[1]);
                    }
                }

                this.settings.dateRangeType = this.getElementAttribute(queryNode, 'dateRangeType');
                this.settings.includeParentEmails = this.getElementAttribute(queryNode, 'includeParentEmails') === 'true';
                this.settings.useEmailCreatedDate = this.getElementAttribute(queryNode, 'useEmailCreatedDate') === 'true';
                this.settings.searchTermsType = this.getElementAttribute(queryNode, 'searchTermsType');
                this.settings.expandDateRange = this.getElementAttribute(queryNode, 'expandDateRange') === 'true';

                this.flags.sent = this.settings.dateRangeType !== 'customDates';
                this.flags.received = this.settings.dateRangeType !== 'customDates';

                this.flags.datestarted = this.settings.dateRangeType !== 'customDates';
                this.flags.dateended = false;

                this.flags.dateaccessed = false;
                this.flags.datecreated = this.settings.dateRangeType !== 'customDates';
                this.flags.datemodified = this.settings.dateRangeType !== 'customDates';

                this.flags.lastaccesstime = false;
                this.flags.createdtime = this.settings.dateRangeType !== 'customDates';
                this.flags.lastmodifiedtime = this.settings.dateRangeType !== 'customDates';

                if (this.settings.dateRangeType === 'customDates') {
                    const properties = Object.keys(this.flags);
                    properties.forEach(prop => {
                        this.flags[prop] = false;
                        if (textValue.includes(prop + this.getEqualityString() + '[')) {
                            this.flags[prop] = true;
                        }
                    });
                }
            }
        }
    }
}

export class MetadataFilter extends SearchFilter {
    anyFilterList = null;
    allFilterList = null;
    noneFilterList = null;
    constructor(value?: Partial<MetadataFilter>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }

    writeXmlFromObject(xmlWriter: XMLWriter): void {
        if (this.anyFilterList || this.allFilterList || this.noneFilterList) {
            xmlWriter.startElement(XmlKeys.QueryKey);
            xmlWriter.writeAttribute(XmlKeys.OccurKey, this.occur);
            xmlWriter.writeAttribute(XmlKeys.CookieKey, this.cookie);
            xmlWriter.writeAttribute(XmlKeys.LabeledClauseKey, this.labeledClause);

            if (this.anyFilterList) {
                this.writeXmlMetadataList(this.anyFilterList, AEQueryElements.SHOULD, xmlWriter);
            }
            if (this.allFilterList) {
                this.writeXmlMetadataList(this.allFilterList, AEQueryElements.MUST, xmlWriter);
            }
            if (this.noneFilterList) {
                this.writeXmlMetadataList(this.noneFilterList, AEQueryElements.MUST_NOT, xmlWriter);
            }
            xmlWriter.endElement(); //query
        }
    }

    toObject(queryNode: Element, isStandardSearch: boolean): void {
        if (queryNode) {
            this.anyFilterList = this.getFiltersFromXmlQuery(queryNode, XmlKeys.GAAnyAdditionalCookieKey);
            this.allFilterList = this.getFiltersFromXmlQuery(queryNode, XmlKeys.GAAllAdditionalCookieKey);
            this.noneFilterList = this.getFiltersFromXmlQuery(queryNode, XmlKeys.GANoneAdditionalCookieKey);
        }
    }

    getFiltersFromXmlQuery(queryNode: Element, cookieKey: XmlKeys): Array<any> {
        let listOfObjects = null;
        const queryNodes = this.getElementsByAttribute(queryNode, XmlKeys.CookieKey, cookieKey);
        if (queryNodes) {
            listOfObjects = [];
            queryNodes.forEach(qn => {
                const rangeNode = this.getElementByName(qn, XmlKeys.RangeKey);
                if (rangeNode) {
                    const fieldValue = this.getElementAttribute(rangeNode, XmlKeys.FieldKey);
                    let beginValue;
                    let endValue;
                    if (rangeNode.childNodes?.length === 2) {
                        beginValue = this.getDateFromString(rangeNode.childNodes[0].textContent);
                        endValue = this.getDateFromString(rangeNode.childNodes[1].textContent);
                        if (isDate(beginValue) || isDate(endValue)) {
                            listOfObjects.push({ selectedValue: fieldValue, startDate: beginValue, endDate: endValue, selectedType: 'date' });
                        } else {
                            beginValue = parseInt(rangeNode.childNodes[0].textContent);
                            endValue = parseInt(rangeNode.childNodes[1].textContent);
                            listOfObjects.push({ selectedValue: fieldValue, minResult: beginValue, maxResult: endValue, selectedType: 'range' });
                        }
                    }
                } else {
                    const textNodes = this.getElementsByName(qn, XmlKeys.TextKey);
                    if (textNodes?.length > 0) {
                        const fieldValue = this.getElementAttribute(textNodes[0], XmlKeys.FieldKey);
                        const textValues = [];
                        textNodes.forEach(txtNode => {
                            textValues.push(txtNode.textContent);
                        });
                        listOfObjects.push({ selectedValue: fieldValue, query: textValues.join(' '), selectedType: 'input' });
                    }
                }
            });
        }
        return listOfObjects;
    }

    writeXmlMetadataList(filterList, operator: AEQueryElements, xmlWriter: XMLWriter): void {
        if (filterList.length > 0) {
            filterList.forEach(metaFilter => {
                if (metaFilter.selectedValue) {
                    xmlWriter.startElement(XmlKeys.QueryKey);
                    xmlWriter.writeAttribute(XmlKeys.OccurKey, operator);
                    const cookieKey = operator === AEQueryElements.MUST_NOT ? XmlKeys.GANoneAdditionalCookieKey : (operator == AEQueryElements.MUST ? XmlKeys.GAAllAdditionalCookieKey : XmlKeys.GAAnyAdditionalCookieKey);
                    xmlWriter.writeAttribute(XmlKeys.CookieKey, cookieKey);
                    if (metaFilter.startDate || metaFilter.endDate) {
                        let dateStart = "0000-00-00-00-00-00";
                        let dateEnd = "9999-12-31-23-59-59";
                        if (metaFilter.startDate) {
                            dateStart = new DatePipe('en-US').transform(metaFilter.startDate, 'yyyy-MM-dd') + '-00-00-00';
                        }
                        if (metaFilter.endDate) {
                            dateEnd = new DatePipe('en-US').transform(metaFilter.endDate, 'yyyy-MM-dd-23-59-59');
                        }
                        xmlWriter.startElement(XmlKeys.RangeKey);

                        xmlWriter.writeAttribute(XmlKeys.TypeKey, 'inclusive');
                        xmlWriter.writeAttribute(XmlKeys.FieldKey, metaFilter.selectedValue);

                        xmlWriter.writeElement(XmlKeys.BeginKey, dateStart);
                        xmlWriter.writeElement(XmlKeys.EndKey, dateEnd);

                        xmlWriter.endElement();//range end
                    } else if (metaFilter.minResult || metaFilter.minResult === 0 || metaFilter.maxResult || metaFilter.maxResult === 0) {
                        if ((metaFilter.minResult || metaFilter.minResult === 0) && (metaFilter.maxResult || metaFilter.maxResult === 0)) {
                            xmlWriter.startElement(XmlKeys.RangeKey);

                            xmlWriter.writeAttribute(XmlKeys.TypeKey, 'inclusive');
                            xmlWriter.writeAttribute(XmlKeys.FieldKey, metaFilter.selectedValue);

                            const minString = metaFilter.minResult?.toString();
                            const maxString = metaFilter.maxResult?.toString();
                            xmlWriter.writeElement(XmlKeys.BeginKey, minString);
                            xmlWriter.writeElement(XmlKeys.EndKey, maxString);

                            xmlWriter.endElement();//range end
                        } else if (metaFilter.minResult || metaFilter.minResult === 0) {
                            this.writeNumberTypeAttribute(xmlWriter, 'min', metaFilter.selectedValue, metaFilter.minResult);
                        } else {
                            this.writeNumberTypeAttribute(xmlWriter, 'max', metaFilter.selectedValue, metaFilter.maxResult);
                        }
                    } else {
                        if (!metaFilter.isPickerSelection) {
                            this.writeTextWithAttributes(xmlWriter, metaFilter.query, metaFilter.selectedValue);
                        }
                        else {
                            const listOfItems = this.getList(metaFilter.query);
                            if (listOfItems.length > 0) {
                                listOfItems.forEach(item => {
                                    if (item) {
                                        this.writeTextWithAttributes(xmlWriter, '\"' + item.replace(/\"/g, '') + '\"', metaFilter.selectedValue);
                                    }
                                });
                            }
                        }
                    }
                    xmlWriter.endElement(); //query
                }
            });
        }
    }

    writeNumberTypeAttribute(xmlWriter: XMLWriter, numberType: string, fieldValue: string, numberValue: number): void {
        xmlWriter.startElement(XmlKeys.TextKey);
        xmlWriter.writeAttribute(XmlKeys.FieldKey, fieldValue);
        xmlWriter.writeAttribute(XmlKeys.NumberTypeKey, numberType);
        xmlWriter.text(numberValue.toString());
        xmlWriter.endElement();
    }

    formatNumber(number, count): string {
        if (number.length < count) {
            let prefix = '';
            for (let i = 0; i < count - number.length; i++) {
                prefix += '0';
            }
            number = prefix + number;
        }
        return number
    }
}

export class SearchWrapper {
    searchConfig = new SearchConfig();

    keywords: SearchFilter = new SearchFilter({ filterType: FilterType.Keywords, simpleParsingNoCookies: this.searchConfig.simpleParsingNoCookies });
    oneOrMoreWords: SearchFilter = null;
    allOfTheseWords: SearchFilter = null;
    noneOfTheseWords: SearchFilter = null;
    theseWordsWithin: WordsWithin = null;
    exactPhrase: SearchFilter = null;
    subject: SearchFilter = null;
    senderRecipient: SenderRecipient = null;
    tags: TagsFilter = null;
    custodians: EntityFilter = null;
    folders: EntityFilter = null;
    domains: DomainsFilter = null;
    aliases: AliasFilter = null;
    dates: DateFilter = null;
    metadatas: MetadataFilter = null;
    populatedFields: string[] = [];

    constructor(config?: SearchConfig) {
        if (config) {
            this.searchConfig = config;
        }

        if (!this.searchConfig.isSimpleSearch) {
            const isStandardSearch = this.searchConfig.searchDialect === AEQueryElements.DRSTANDARD;
            const occurValue = this.searchConfig.isFromCombinedSearch ? (isStandardSearch ? AEQueryElements.MUST : null) : AEQueryElements.MUST;
            this.oneOrMoreWords = new SearchFilter({
                labeledClause: 'One_Or_More_Words', occur: occurValue,
                filterType: FilterType.Words, isFromCombinedSearch: this.searchConfig.isFromCombinedSearch
            });
            this.allOfTheseWords = new SearchFilter({
                labeledClause: 'All_Of_These_Words', occur: occurValue,
                filterType: FilterType.Words, isFromCombinedSearch: this.searchConfig.isFromCombinedSearch
            });

            if (!this.searchConfig.isFromCombinedSearch) {
                this.noneOfTheseWords = new SearchFilter({ labeledClause: 'None_Of_These_Words', filterType: FilterType.Words, occur: AEQueryElements.MUST_NOT });
                this.exactPhrase = new SearchFilter({ filterType: FilterType.ExactPhrase });
                this.theseWordsWithin = new WordsWithin({ filterType: FilterType.WordsWithin });
                this.subject = new SearchFilter({ filterType: FilterType.Subject });
                this.senderRecipient = new SenderRecipient({ filterType: FilterType.SenderRecipient });
                this.tags = new TagsFilter({ filterType: FilterType.Tag });
                this.custodians = new EntityFilter({ filterType: FilterType.Custodian });
                this.folders = new EntityFilter({ filterType: FilterType.Folder });
                this.domains = new DomainsFilter({ filterType: FilterType.Domain });
                this.aliases = new AliasFilter({ filterType: FilterType.Alias });
                this.dates = new DateFilter({ filterType: FilterType.Date });
                this.metadatas = new MetadataFilter({ filterType: FilterType.Metadata });
            }
        }
    }

    objectToXml(): string {
        const xw = new XMLWriter();
        xw.startDocument('1.0', 'UTF-8');
        xw.startElement(XmlKeys.QueryKey);

        xw.writeAttribute(XmlKeys.DialectKey, this.searchConfig.searchDialect);

        if (this.searchConfig.isFromFreeFormQuery && !this.searchConfig.simpleParsingNoCookies) {
            xw.writeAttribute(XmlKeys.IsFromFreeFormTextKey, 'true');
        }
        if (this.searchConfig.searchDialect.toString() === AEQueryElements.DRCLASSIC) {
            this.keywords.occur = null;
        }
        if (!this.searchConfig.simpleParsingNoCookies) {
            xw.writeAttribute(XmlKeys.CookieKey, this.searchConfig.isSimpleSearch ? 'DRSimpleSearch' : 'DRAdvancedSearch');

            if (this.searchConfig.isSimpleSearch) {
                xw.writeAttribute(XmlKeys.SimpleSearchExpandedKey, this.searchConfig.isSimpleSearchExpanded.toString());
            }
        }
        this.keywords.writeXmlFromObject(xw);
        if (!this.searchConfig.isSimpleSearch) {
            this.oneOrMoreWords.writeXmlFromObject(xw);
            this.allOfTheseWords.writeXmlFromObject(xw);
            if (!this.searchConfig.isFromCombinedSearch) {
                this.noneOfTheseWords.writeXmlFromObject(xw);
                this.exactPhrase.writeXmlFromObject(xw);
                this.theseWordsWithin.writeXmlFromObject(xw, this.searchConfig.searchDialect === AEQueryElements.DRSTANDARD);
                this.subject.writeXmlFromObject(xw);
                this.senderRecipient.writeXmlFromObject(xw);
                this.tags.writeXmlFromObject(xw);
                this.dates.writeXmlFromObject(xw, this.searchConfig.searchDialect === AEQueryElements.DRSTANDARD);
                this.domains.writeXmlFromObject(xw);
                this.custodians.writeXmlFromObject(xw);
                this.folders.writeXmlFromObject(xw);
                this.aliases.writeXmlFromObject(xw);
                this.metadatas.writeXmlFromObject(xw);
            }
        }

        xw.endElement();
        xw.endDocument();

        return xw.toString();
    }

    xmlQueryToObject(xmlQuery: string): void {
        if (xmlQuery) {
            const xmlObj = jquery.parseXML(xmlQuery);
            if (xmlObj && xmlObj.childNodes && xmlObj.childNodes[0] && xmlObj.childNodes[0].childNodes) {
                const filterKeys = [];
                for (const key in this) {
                    if (Object.prototype.hasOwnProperty.call(this, key)) {
                        filterKeys.push(key);
                    }
                }
                const nodeArray = Array.from(xmlObj.childNodes[0].childNodes as [Element]);
                const nodeArrayLength = nodeArray.length;
                for (let nodeIndex = 0; nodeIndex < nodeArrayLength; nodeIndex++) {
                    const element = nodeArray[nodeIndex];
                    if (element && element.attributes) {
                        let cookieValue;
                        for (let elemIndex = 0; elemIndex < element.attributes.length; elemIndex++) {
                            if (element.attributes[elemIndex].name === XmlKeys.CookieKey) {
                                cookieValue = element.attributes[elemIndex].value;
                                break;
                            }
                        }
                        if (cookieValue) {
                            const montie = cookieValue;
                            let filterKey;
                            for (let filterIndex = 0; filterIndex < filterKeys.length; filterIndex++) {
                                const key = filterKeys[filterIndex];
                                if (this[key] instanceof SearchFilter && (this[key] as SearchFilter).cookie === montie) {
                                    filterKey = key;
                                    break;
                                }
                            }
                            if (filterKey) {
                                const filter = this[filterKey] as SearchFilter;
                                filter.toObject(element, this.searchConfig.searchDialect === AEQueryElements.DRSTANDARD);
                                this.populatedFields.push(filter.cookie);
                            }
                        }
                    }
                }
            }
        }
    }
}

const familyKeywords = [
    AEQueryElements.parent_of,
    AEQueryElements.child_of,
    AEQueryElements.children_of,
    AEQueryElements.family_of,
    AEQueryElements.root_of,
    'w/',
    'pre/'
];
const archiveKeywords = [
    AEQueryElements.archive_of,
    AEQueryElements.nested_archive_of,
    AEQueryElements.archive_contents
]
const metadata = [
    'acls',
    'AllPaths',
    'AltBcc_Address',
    'AltBcc_Name',
    'altbcc',
    'AltCc_Address',
    'AltCc_Name',
    'altcc',
    'AltFrom_Address',
    'AltFrom_Name',
    'altfrom',
    'altparticipants',
    'AltSender_Address',
    'AltSender_Name',
    'altsender',
    'AltTo_Address',
    'AltTo_Name',
    'altto',
    'ancestordahandle',
    'ApplicationName',
    'AttachmentID',
    'AttachmentRange',

    'attachmentsmd5',
    'attachments',
    'attendees',
    'author',
    'auxfiletype',
    'averagenumberoftermsperpage',

    'batch',
    'batch_view',
    'bcc',
    'BegAttach',
    'BegDoc',

    'blocksize',
    'bloombergdisclaimer',
    'bloomberglanguage',
    'bloombergtype',
    'bloomberguser',
    'bloombergversion',

    'bytecount',

    'category',

    'charcountlongestword',
    'charcount',

    'checkedby',

    'client',
    'Clusters',
    'cluster_view_plus_similarity',
    'cluster_view',

    'company',
    'containerfolder',

    'contentdescription',

    'contentdisposition',

    'contentid',

    'contentlanguage',

    'contentmd5',
    'contentransferencoding',

    'contenttype',
    'conversationindexguid',
    'conversationindex',
    'createdtime',
    'custodian_view',
    'custodian',
    'dafilesource',
    'dafilestatetime',
    'dafilestate',
    'daghandle',

    'dateaccessed',
    'DateAccessed',

    'datebackedup',
    'DateBackedUp',

    'datecompleted',
    'DateCompleted',

    'datecreated',
    'DateCreated',
    'DateCreateSystem',
    'datedue',
    'DateDue',

    'dateedited',
    'DateEdited',
    'dateended',
    'DateEnded',
    'DateEWFAcquired',
    'DateExported',
    'DateFlagCompleted',
    'DateFlagDue',
    'DateFlagStarted',
    'DateLastAccessed',
    'DateLastChanged',
    'DateLastModSystem',
    'DateLastMod',
    'DateLastPrinted',
    'DateMediaCreated',

    'datemodified',
    'dateoffset',
    'dateprimary',
    'DatePrimary',

    'dateprinted',
    'DateProcessed',
    'DateReceived',
    'DateRecorded',

    'datescanned',
    'DateSent',
    'datestarted',
    'DateStarted',
    'datetaken',
    'datezone',

    'deliveredto',
    'deliveryreportrequested',

    'department',
    'depotfile',

    'description',

    'destination',

    'dirchildcount',
    'disclaimerreference',
    'diskpartitionstatus',
    'diskpartitions',

    'disposition',

    'division',
    'docannotations',
    'docclass',
    'DocDate',
    'docnum',

    'documentnumber',
    'DocumentRange',
    'dominantlanguage',
    'dr_loc',
    'drcontaineroffset',
    'drrelativepath',
    'dupe_fingerprint',
    'DupeFingerprintSha1',
    'DuplicateCustodianOther',
    'DuplicateCustodian',
    'Duplicate_Source_DocID',
    'Duplicate',
    'E_MailClient',

    'editor',

    'edocsubject',
    'emailheader',
    'embeddedchildren',
    'embeddedlink',
    'embeddedparent',
    'EndAttach',
    'EndDoc',
    'entryid',
    'ewfcasenumber',
    'ewfdateacquired',
    'ewfevidencenumber',
    'ewfexaminername',
    'ewfmd5',
    'ewfmediasize',
    'ExceptionDescCode',
    'exceptiontext',
    'Exception',

    'ExportDupePriority',
    'ExportedVolName',
    'Exported',
    'export_view_docid',
    'export_view_dupe_priority',
    'export_view_enddoc',
    'export_view_reason_code',
    'export_view',
    'extbegattach',
    'extbegdoc',
    'extdahandle',
    'extdarelativepath',
    'extdocattachrange',
    'extdocrange',
    'extendattach',
    'extenddoc',
    'extendedfilename',
    'extendedproperties',
    'extnumpages',
    'extprocessed',
    'ExtReprocessed',
    'family_fingerprint',
    'family_handle',
    'fileattr',

    'filemd5',
    'filemode',

    'filename',
    'filesha1',
    'filesubtype',
    'filetype',
    'flagcompleted',
    'flagdue',
    'flagstarted',

    'forwardto',

    'from',
    'fullparticipants',
    'fullpath',
    'greeting',

    'group_view',
    'HasMSReviewInfo',
    'hastransportheader',
    'hiddendata',

    'hiddenslidecount',
    'image_exception',

    'importance',
    'ImportArea',
    'ImportDevice',
    'importpath',
    'ImportPathInfo',
    'ImportURL',
    'inode',

    'inreplyto',
    'journalemailhandle',
    'journalemailparent',
    'journalemailtype',

    'keywords',
    'KFT',
    'kftdesc',

    'language',
    'lastaccesstime',
    'lastchangetime',
    'lastmodifiedtime',

    'linecount',
    'linksdirty',
    'loadfiledocsource',
    'location',
    'maghandle',
    'mailcategories',
    'mailcontainer',
    'mailcontainererror',
    'mailflags',
    'mailfolder',
    'mailfolderpath',
    'mailpriority',

    'mailstop',
    'MailStore',

    'manager',
    'markuphistory',
    'Matter',
    'mboxfromline',
    'mediacreationtime',
    'mediaencoder',
    'mediaformat',
    'mediaid',
    'mediaid_view',

    'messageid',
    'mimeversion',

    'mmclipcount',

    'modifiedby',
    'msgclass',
    'msgsource',
    'msoutlookmessageclass',
    'msoutlooktextsources',
    'msreviewauthoraddr',
    'msreviewauthorname',
    'msreviewcycle',
    'msreviewemailsubject',
    'msreviewprevcycle',
    'NativeLinkBytes',
    'NativeLinkExt',
    'NativeLink',
    'NearDupePivotDocID',
    'NearDupePivotSimilarity',
    'NearDupePivotSource',
    'NearDupe',

    'notescount',
    'nsfform',
    'nsftemplate',
    'nsfunavailableformdetails',
    'NumAttach',
    'numemailparticipants',
    'numemailrecipients',
    'ocraverageconfidencelevel',
    'ocrlowestconfidencelevel',
    'ocrpath',
    'ocrstatus',
    'ocrsuspectwords',
    'ocrtotalpages',
    'ocrvalidpages',
    'ocrwords',

    'office',
    'OLEChildID',
    'OLEParentID',
    'OrderByDate',
    'origdocext',
    'origparsingstatus',
    'osfolder',

    'ownergroup',
    'owneruser',
    'owner',

    'pagecount',
    'PageCount',

    'paragraphcount',

    'ParentContainerType',
    'ParentContainer',
    'ParentID',
    'parent',
    'parseduration',
    'parserversion',
    'parsingstatus',
    'participantdomains',
    'password',
    'pattern',
    'patternvalue',
    'PDFLinkBytes',
    'PDFLink',
    'processedstatus',
    'ProducedCustodian',

    'ProjectMatterName',
    'project',

    'publisher',
    'rcvddomains',
    'readreceiptrequested',

    'receivedexists',
    'receivedoffset',
    'receivedzone',
    'received',

    'receiveheader',

    'recipientsmd5',
    'recipient',

    'recordedby',

    'recordeddate',

    'references',
    'reference',
    'Responsive',

    'returnpath',
    'reviewfolder',

    'revision',

    'scale',
    'sdcontrol',
    'SearchID',
    'searchterms',

    'Sender_Address',
    'Sender_Name',
    'sender',
    'sensitivity',

    'sentdomains',
    'sentexists',
    'sentoffset',
    'sentzone',
    'sent',

    'size',

    'slidecount',

    'source',

    'status',
    'stored_image',

    'subject',
    'TagID',
    'tag_view',
    'TextLink',
    'TextLinkBytes',
    'thread_handle',
    'threadgroupid',
    'ThreadGroupIndent',
    'ThreadGroupSort',
    'ThreadIDOrphanRef',
    'ThreadIDParent',
    'ThreadIDParentRef',
    'ThreadID',
    'thread_inclusive',
    'threadindex',
    'threadtopic',
    'TimeAccessed',
    'TimeBackedUp',
    'TimeCompleted',
    'TimeCreated',
    'TimeCreateSystem',
    'TimeDue',
    'TimeEdited',
    'TimeEnded',
    'TimeEWFAcquired',
    'TimeFlagCompleted',
    'TimeFlagDue',
    'TimeFlagStarted',
    'TimeLastAccessed',
    'TimeLastChanged',
    'TimeLastModSystem',
    'TimeLastMod',
    'TimeLastPrinted',
    'TimeMediaCreated',
    'TimePrimary',
    'TimeProcessed',
    'TimeReceived',
    'TimeRecorded',
    'TimeSent',
    'TimeStarted',
    'TimeZone',
    'TimeZoneOffset',

    'title',

    'trackchanges',

    'typist',
    'unid',
    'virus',
    'VolName',

    'wordcount',

    'DocTime',
    'DateTaken',
    'TimeTaken',
    'SMF_DeletionDate',
    'SMF_DeletionTime',
    'SMF_ThreadLastActivityDate',
    'SMF_ThreadLastActivityTime',
    'SMF_ThreadStartDate',
    'SMF_ThreadStartTime',

    'smf_channel_name',
    'smf_chatid',
    'smf_datatype',
    'smf_deleted',
    'smf_deletiondatetime',
    'smf_direction',
    'smf_event_attendees',
    'smf_event_availability',
    'smf_event_category',
    'smf_event_details',
    'smf_event_location',
    'smf_event_repeatday',
    'smf_event_repeatinterval',
    'smf_event_repeatrule',
    'smf_fileid',
    'smf_filepath',
    'smf_filesystem',
    'smf_folder',
    'smf_iscarved',
    'smf_isinfected',
    'smf_message_body',
    'smf_message_deleted',
    'smf_message_status',
    'smf_message_type',
    'smf_overflow',
    'smf_platform',
    'smf_source_application',
    'smf_sourcefile',
    'smf_sourcefilename',
    'smf_sourcefilepath',
    'smf_sourceindex',
    'smf_sourcerecordid',
    'smf_tags',
    'smf_threaddeleted',
    'smf_threadlastactivitydatetime',
    'smf_threadname',
    'smf_threadsource',
    'smf_threadstartdatetime',
    'smf_all_attachments',
    'smf_application',
    'smf_attachmentcount',
    'smf_call_duration',
    'smf_called_number',
    'smf_cellebrite_description',
    'smf_cellebrite_lastactivity',
    'smf_cellebrite_name',
    'smf_cellebrite_starttime',
    'smf_cellebrite_subdir',
    'smf_cellebrite_type',
    'smf_containsdeleted',
    'smf_containsedited',
    'smf_conversation_calltype',
    'smf_conversation_timezoneeverywhere',
    'smf_conversation_timezoneoffset',
    'smf_conversationtype',
    'smf_custodian',
    'smf_eventCollectionid',
    'smf_event_id',
    'smf_event_type',
    'smf_fullparticipants_identifier',
    'smf_generator',
    'smf_hash',
    'smf_id',
    'smf_imei',
    'smf_importance',
    'smf_imsi',
    'smf_informational',
    'smf_messagedirection',
    'smf_messagestatus',
    'smf_msisdn',
    'smf_partcipant_display',
    'smf_partcipant_id',
    'smf_participant_status',
    'smf_participantcount',
    'smf_phone_owner',
    'smf_relativity_attachmentid',
    'smf_role',
    'smf_source',
    'smf_threadcount',
    'smf_timezone',
    'smf_version',
    'smf_video_call',

    'to',
    'childcount',
    'comments',
    'comment',
    'container',
    'dahandle',
    'darelativepath',
    'date',
    'docext',
    'DocID',
    'group',
    'handle',
    'participants',
    'auxparsingstatus',
    'modernattachmentlinks',
    'cc',
    'bcc_identifier',
    'bcc_name',
    'cc_identifier',
    'cc_name',
    'edrmdupeid',
    'from_identifier',
    'from_name',
    'isattach',
    'participants_identifier',
    'participants_name',
    'recipient_identifier',
    'recipient_name',
    'to_identifier',
    'to_name', // put at the end so that words containing it matches first

    'content',
    'contents', //not metadata fields but should be highlighted as them
    'filesha256',
    'smf_team_name'
];

const exportOnlyFields = [
    'AllPaths',
    'AltBcc_Address',
    'AltBcc_Name',
    'AltCc_Address',
    'AltCc_Name',
    'AltFrom_Address',
    'AltFrom_Name',
    'AltSender_Address',
    'AltSender_Name',
    'AltTo_Address',
    'AltTo_Name',
    'ApplicationName',
    'AttachmentID',
    'AttachmentRange',
    'BegAttach',
    'BegDoc',

    'Clusters',
    'DateAccessed',
    'DateBackedUp',
    'DateCompleted',
    'DateCreated',
    'DateCreateSystem',
    'DateDue',
    'DateEdited',
    'DateEnded',
    'DateEWFAcquired',
    'DateExported',
    'DateFlagCompleted',
    'DateFlagDue',
    'DateFlagStarted',
    'DateLastAccessed',
    'DateLastChanged',
    'DateLastModSystem',
    'DateLastMod',
    'DateLastPrinted',
    'DateMediaCreated',
    'DatePrimary',
    'DateProcessed',
    'DateReceived',
    'DateRecorded',
    'DateSent',
    'DateStarted',
    'DocDate',
    'DocID',
    'DocumentRange',
    'DocTime',
    'DupeFingerprintSha1',
    'DuplicateCustodianOther',
    'DuplicateCustodian',
    'Duplicate_Source_DocID',
    'Duplicate',

    'E_MailClient',
    'EndAttach',
    'EndDoc',
    'ExceptionDescCode',
    'Exception',

    'ExportDupePriority',
    'ExportedVolName',
    'Exported',
    'ExtReprocessed',

    'HasMSReviewInfo',

    'ImportArea',
    'ImportDevice',
    'ImportPathInfo',
    'ImportURL',

    'KFT',

    'MailStore',
    'Matter',

    'NativeLinkBytes',
    'NativeLinkExt',
    'NativeLink',
    'NearDupePivotDocID',
    'NearDupePivotSimilarity',
    'NearDupePivotSource',
    'NearDupe',
    'NumAttach',

    'OLEChildID',
    'OLEParentID',
    'OrderByDate',

    'PageCount',
    'ParentContainerType',
    'ParentContainer',
    'ParentID',
    'PDFLinkBytes',
    'PDFLink',
    'ProducedCustodian',
    'ProjectMatterName',

    'Responsive',

    'SearchID',
    'searchterms',
    'Sender_Address',
    'Sender_Name',

    'DateTaken',
    'TimeTaken',
    'SMF_DeletionDate',
    'SMF_DeletionTime',
    'SMF_ThreadLastActivityDate',
    'SMF_ThreadLastActivityTime',
    'SMF_ThreadStartDate',
    'SMF_ThreadStartTime',

    'TagID',
    'TextLink',
    'TextLinkBytes',
    'ThreadGroupID',
    'ThreadGroupIndent',
    'ThreadGroupSort',
    'ThreadIDOrphanRef',
    'ThreadIDParent',
    'ThreadIDParentRef',
    'ThreadID',
    'ThreadInclusive',
    'TimeAccessed',
    'TimeBackedUp',
    'TimeCompleted',
    'TimeCreated',
    'TimeCreateSystem',
    'TimeDue',
    'TimeEdited',
    'TimeEnded',
    'TimeEWFAcquired',
    'TimeFlagCompleted',
    'TimeFlagDue',
    'TimeFlagStarted',
    'TimeLastAccessed',
    'TimeLastChanged',
    'TimeLastModSystem',
    'TimeLastMod',
    'TimeLastPrinted',
    'TimeMediaCreated',
    'TimePrimary',
    'TimeProcessed',
    'TimeReceived',
    'TimeRecorded',
    'TimeSent',
    'TimeStarted',
    'TimeZone',
    'TimeZoneOffset',

    'VolName',
]

@Injectable()
export class XMLService {
    readonly colorizedOr = '<span class="colorized-or">OR</span>';
    readonly colorizedAnd = '<span class="colorized-and">AND</span>';
    readonly colorizedPlus = '<span class="colorized-and">+</span>';
    readonly colorizedNot = '<span class="colorized-not">NOT</span>';
    readonly colorizedMinus = '<span class="colorized-not">-</span>';
    readonly colorizedLeftParen = '<span class="colorized-paren">(</span>';
    readonly colorizedRightParen = '<span class="colorized-paren">)</span>';

    private outputBuilder = {
        occur: {
            or: (returnHtmlContent = false): string => {
                return returnHtmlContent ? this.colorizedOr : 'OR';
            },
            and: (returnHtmlContent = false): string => {
                return returnHtmlContent ? this.colorizedAnd : 'AND';
            },
            plus: (returnHtmlContent = false): string => {
                return returnHtmlContent ? this.colorizedPlus : '+';
            },
            not: (returnHtmlContent = false): string => {
                return returnHtmlContent ? this.colorizedNot : 'NOT';
            },
            minus: (returnHtmlContent = false): string => {
                return returnHtmlContent ? this.colorizedMinus : '-';
            }
        },
        family: (val: string, returnHtmlContent = false): string => {
            return returnHtmlContent ? `<span class="colorized-family">${val}</span>` : val;
        },
        fieldStart: (val: string, returnHtmlContent = false): string => {
            return returnHtmlContent ? `<span class="unbreakable"><span class="colorized-meta">${val}</span>` : val;
        },
        fieldEnd: (returnHtmlContent = false): string => {
            return returnHtmlContent ? '</span>' : '';
        },
        parenOpen: (returnHtmlContent = false): string => {
            return returnHtmlContent ? this.colorizedLeftParen : '(';
        },
        parenClose: (returnHtmlContent = false): string => {
            return returnHtmlContent ? this.colorizedRightParen : ')';
        }
    };

    readonly highlightLanguage = function (hljs) {
        return {
            case_insensitive: true, // language is case-insensitive
            keywords: {
                family: familyKeywords.join(' '),
                archive: archiveKeywords.join(' ')
            },
            contains: [
                {
                    className: 'paren',
                    begin: /[\(\)]/, excludeEnd: true
                },
                {
                    className: 'or',
                    begin: /\bor\b/, end: /[\s()"']/, excludeEnd: true
                },
                {
                    className: 'and',
                    begin: /\band\b/, end: /[\s()"']/, excludeEnd: true
                },
                {
                    className: 'not',
                    begin: /\bnot\b/, end: /[\s()"']/, excludeEnd: true
                },
                {
                    className: 'contains',
                    begin: /\bcontains\b/, end: /[\s()"']/, excludeEnd: true
                },
                {
                    className: 'meta',
                    begin: new RegExp('\\b(?:' + metadata.filter(f => exportOnlyFields.indexOf(f) === -1).join('|') + ')\\b::')
                },
                {
                    className: 'pre',
                    begin: /\bpre\/\b/, end: /[\s()"']/, excludeEnd: true
                },
                {
                    className: 'w',
                    begin: /\bw\/\b/, end: /[\s()"']/, excludeEnd: true
                },
                {
                    className: 'string',
                    begin: '"', end: '"',
                    contains: []
                }
            ]
        };
    };

    constructor(private commonService: CommonService) {
        (window as any).hljs?.registerLanguage('query', this.highlightLanguage as any);
        (window as any).hljs?.configure({
            tabReplace: ' ',
            languages: ['query'],
            useBR: false
        });
    }

    isDateQuery(xmlString: string): boolean {
        const config = new SearchConfig({ isSimpleSearch: false });
        const advancedSearchWrapper = new SearchWrapper(config);
        advancedSearchWrapper.xmlQueryToObject(xmlString);
        const hasDates = advancedSearchWrapper.populatedFields.indexOf(XmlKeys.GADateFiltersCookieKey) !== -1;
        return hasDates && advancedSearchWrapper.populatedFields.length === 1;
    }

    stringToXMLQuery(queryString: string, expanded = false, noCookies?: boolean, isSimpleSearch = true): string {
        if (queryString) {
            const config = new SearchConfig({
                searchDialect: this.commonService.searchDialect, isSimpleSearchExpanded: expanded,
                simpleParsingNoCookies: noCookies, isSimpleSearch: isSimpleSearch
            });
            const searchWrapper = new SearchWrapper(config);
            searchWrapper.keywords.value = queryString;
            return searchWrapper.objectToXml();
        }
        return null;
    }

    objectToXMLQuery(searchWrapper: SearchWrapper): string {
        if (searchWrapper) {
            return searchWrapper.objectToXml();
        }
        return null;
    }

    xmlToQueryConverter(xml: string, getQueryWithInfo = false, returnHtmlContent = false, escapeAngleBrackets = false): string | Record<string, unknown> {
        if (xml === null || isUndefined(xml)) {
            return null;
        }
        let xmlObj;
        let query;

        try {
            xmlObj = jquery.parseXML(xml);
            query = this.parseTopXML(jquery(xmlObj), returnHtmlContent, escapeAngleBrackets);
            if (returnHtmlContent) {
                if (!query || query === (this.outputBuilder.parenOpen(true) + this.outputBuilder.parenClose(true))) {
                    query = '';
                }
                query = '<span>' + query + '</span>';
            }
        } catch (e) {
            console.error(e);
            return null;
        }

        if (getQueryWithInfo) {
            const xmlRoot = jquery(xmlObj).children()[0];
            const dialect = this.parseXMLDialect(xmlRoot);
            const searchType = jquery(xmlRoot).attr(AEQueryElements.cookie);
            const field = jquery(xmlRoot).attr(AEQueryElements.field);
            const queryObj = { query: query, searchType: searchType, dialect: dialect };
            if (field) {
                queryObj['field'] = field;
            }
            const isFromFreeForm = jquery(xmlRoot).attr('IsFromFreeFormText');

            if (searchType && (searchType === 'DRSimpleSearch' || searchType === 'DRQuickSearch')) {
                const isExpandedFlag = jquery(xmlRoot).attr('SimpleSearchExpanded');

                queryObj['isSimpleSearchExpanded'] = isExpandedFlag ? isExpandedFlag : false;
            } else if (searchType === 'DRAdvancedSearch' || isFromFreeForm) {
                queryObj['IsFromFreeFormText'] = isFromFreeForm ? isFromFreeForm : false;
                if (!searchType) {
                    queryObj.searchType = 'DRAdvancedSearch';
                }
            }
            return queryObj;
        }

        return query;
    }

    private parseTopXML(xml: jquery, html = false, escapeAngleBrackets = false): string {
        // Expect to start with a query
        if (!xml || !xml.children() || xml.children()[0]?.nodeName !== AEQueryElements.query) {
            console.error('Query does not start with a query specification!');
            return null;
        } else {
            const dialect = this.parseXMLDialect(xml.children()[0]);
            return this.parseXMLNode(xml.children()[0], null, dialect, false, html, escapeAngleBrackets);
        }
    }

    private parseXMLDialect(xml: Record<string, unknown>): AEQueryElements.DRCLASSIC | AEQueryElements.DRSTANDARD {
        let dialect = jquery(xml).attr(AEQueryElements.dialect);
        if (dialect !== AEQueryElements.DRCLASSIC &&
            dialect !== AEQueryElements.DRSTANDARD) {
            console.warn('Invalid dialect found; defaulting to classic');
            dialect = AEQueryElements.DRCLASSIC;
        }
        return dialect;
    }

    private parseXMLOrder(xml: Record<string, unknown>): boolean {
        const order = jquery(xml).attr(AEQueryElements.order);
        return order === AEQueryElements.ordered;
    }

    private parseXMLDistance(xml: Record<string, unknown>): string {
        const distance = jquery(xml).attr(AEQueryElements.distance);
        return isNaN(parseInt(distance, 10)) ? '' : distance;
    }

    private parseXMLOccur(xml: Record<string, unknown>): AEQueryElements.MUST | AEQueryElements.MUST_NOT | AEQueryElements.SHOULD {
        let occur = jquery(xml).attr(AEQueryElements.occur);

        if (occur !== AEQueryElements.MUST_NOT &&
            occur !== AEQueryElements.MUST &&
            occur !== AEQueryElements.SHOULD) {
            occur = AEQueryElements.SHOULD;
        }
        return occur;
    }

    private parseXMLRange(xml: Record<string, unknown>): AEQueryElements.inclusive | AEQueryElements.inclusive_exclusive | AEQueryElements.exclusive | AEQueryElements.exclusive_inclusive {
        const range = jquery(xml).attr(AEQueryElements.type);
        if (!range) {
            console.error('Missing range query type.');
            return null;
        }
        switch (range) {
            case AEQueryElements.inclusive:
            case AEQueryElements.inclusive_exclusive:
            case AEQueryElements.exclusive:
            case AEQueryElements.exclusive_inclusive: {
                return range;
            }
        }
        console.error('Invalid range query type');
        return null;
    }

    private parseXMLNode(xml: Record<string, unknown>, type: AEQueryElements, dialect: string, non_proximity: boolean, html = false, escapeAngleBrackets = false): string {
        let outputString = '';
        let occur;
        let occurString = '';
        let distanceString = '';
        let ordered;

        if (type === AEQueryElements.clause_proximity) {
            ordered = this.parseXMLOrder(xml);
            distanceString = this.parseXMLDistance(xml);
            if (!xml || !jquery(xml).children() || jquery(xml).children()[0].nodeName !== AEQueryElements.query) {
                console.error('Missing query inside clause proximity!');
                console.error(xml);
                return '';
            }
            // immediately step inside the query and process from there
            xml = jquery(xml).children()[0];
        }

        occur = this.parseXMLOccur(jquery(xml).children().first());

        if (type !== AEQueryElements.clause_proximity) {
            if (dialect === AEQueryElements.DRCLASSIC) {
                occurString = ' ';
            } else {
                if (occur === AEQueryElements.MUST) {
                    occurString = ` ${this.outputBuilder.occur.and(html)} `;
                } else if (occur === AEQueryElements.MUST_NOT) {
                    occurString = ` ${this.outputBuilder.occur.and(html)} `;
                } else if (occur === AEQueryElements.SHOULD) {
                    occurString = ` ${this.outputBuilder.occur.or(html)} `;
                }
            }
        } else {
            if (non_proximity) {
                occurString = ` ${this.outputBuilder.occur.not(html)}`;
            }
            if (dialect === AEQueryElements.DRSTANDARD) {
                if (ordered && distanceString === '0') {
                    occurString += ' ';
                } else {
                    occurString += (ordered ? ` ${this.outputBuilder.family('pre/', html)}` : ` ${this.outputBuilder.family('w/', html)}`) + (parseInt(distanceString, 10) + 1) + ' ';
                }
            } else {
                if (ordered && distanceString === '0') {
                    occurString += ' ';
                } else {
                    occurString += (ordered ? '~o' : '~u') + distanceString;
                }
            }
        }

        let isFirst = true;

        if (type === AEQueryElements.query || (type === AEQueryElements.clause_proximity && distanceString === '0')) {
            outputString += this.outputBuilder.parenOpen(html);
        }

        const cookieFilter = jquery(xml).attr(AEQueryElements.cookie);

        _.each(jquery(xml).children(), (element, index) => {
            // #region ECASL-27668 - brackets formatting
            let isSpecificType = true;
            if (isFirst && cookieFilter && (cookieFilter === XmlKeys.CustodiansCookieKey ||
                cookieFilter === XmlKeys.FoldersCookieKey) &&
                (type === AEQueryElements.query || type === AEQueryElements.clause_proximity)) {
                outputString += this.outputBuilder.parenOpen(html);
            } else if (!(cookieFilter && (cookieFilter === XmlKeys.CustodiansCookieKey ||
                cookieFilter === XmlKeys.FoldersCookieKey || cookieFilter === XmlKeys.GAAliasCookieKey))) {
                isSpecificType = false;
            }

            const prevChildNode = jquery(xml).children()[index - 1];
            let currentField, prevNodeField, prevNodeOccur, nextNodeField, nextNodeOccur, nextNodeAliasField;
            let aliasNodeFieldName, currentNodeAliasField, prevNodeAliasField;
            if (prevChildNode) {
                currentField = jquery(element).attr(AEQueryElements.field);
                prevNodeField = jquery(prevChildNode).attr(AEQueryElements.field);
                prevNodeOccur = this.parseXMLOccur(prevChildNode);

                aliasNodeFieldName = jquery(element).attr(AEQueryElements.aliasname);
                currentNodeAliasField = jquery(element).attr(AEQueryElements.searchtype);
                prevNodeAliasField = jquery(prevChildNode).attr(AEQueryElements.searchtype);
            }

            const nextChildNode = jquery(xml).children()[index + 1];
            if (nextChildNode) {
                nextNodeField = jquery(nextChildNode).attr(AEQueryElements.field);
                nextNodeOccur = this.parseXMLOccur(nextChildNode);
                nextNodeAliasField = jquery(nextChildNode).attr(AEQueryElements.searchtype);
            }
            // #endregion

            if (!isFirst) {
                if (dialect === AEQueryElements.DRSTANDARD) {
                    if (type !== AEQueryElements.clause_proximity) {
                        const getOccurance = jquery(element).attr(AEQueryElements.occur);
                        if (getOccurance) {
                            occur = this.parseXMLOccur(element);
                        }

                        if (occur === AEQueryElements.MUST) {
                            if (aliasNodeFieldName && (currentNodeAliasField === 'somealiases' || currentNodeAliasField === 'nonealiases') &&
                                currentNodeAliasField !== prevNodeAliasField && currentNodeAliasField === nextNodeAliasField && isSpecificType) {
                                occurString = ` ${this.outputBuilder.occur.and(html)} ${this.outputBuilder.parenOpen(html)}`;
                            } else if (aliasNodeFieldName && prevNodeOccur === occur && occur === nextNodeOccur && isSpecificType) {
                                occurString = ` ${this.outputBuilder.occur.and(html)} `;
                            } else {
                                occurString = (prevChildNode && prevNodeField !== currentField || prevNodeOccur !== occur) && isSpecificType ?
                                    ` ${this.outputBuilder.occur.and(html)} ${this.outputBuilder.parenOpen(html)}` : ` ${this.outputBuilder.occur.and(html)} `;
                            }
                        } else if (occur === AEQueryElements.MUST_NOT) {
                            occur = getOccurance ? occur : this.parseXMLOccur(element);
                            if (aliasNodeFieldName && (currentNodeAliasField === 'somealiases' || currentNodeAliasField === 'nonealiases') &&
                                currentNodeAliasField !== prevNodeAliasField && currentNodeAliasField === nextNodeAliasField && isSpecificType) {
                                occurString = ` ${this.outputBuilder.occur.and(html)} ${this.outputBuilder.parenOpen(html)}`;
                            } else if (aliasNodeFieldName && prevNodeOccur === occur && isSpecificType) {
                                occurString = ` ${this.outputBuilder.occur.and(html)} `;
                            } else {
                                occurString = (prevChildNode && prevNodeField !== currentField || prevNodeOccur !== occur) && isSpecificType ?
                                    ` ${this.outputBuilder.occur.and(html)} ${this.outputBuilder.parenOpen(html)}` : ` ${this.outputBuilder.occur.and(html)} `;
                            }
                        } else if (occur === AEQueryElements.SHOULD) {
                            if (aliasNodeFieldName && (currentNodeAliasField === 'somealiases' || currentNodeAliasField === 'nonealiases') &&
                                currentNodeAliasField !== prevNodeAliasField && currentNodeAliasField === nextNodeAliasField && isSpecificType) {
                                occurString = ` ${this.outputBuilder.occur.and(html)} ${this.outputBuilder.parenOpen(html)}`;
                            } else if (aliasNodeFieldName && prevNodeOccur === occur && (occur === nextNodeOccur || !nextNodeOccur) && isSpecificType) {
                                occurString = ` ${this.outputBuilder.occur.or(html)} `;
                            } else {
                                occurString = (prevChildNode && prevNodeField !== currentField && prevNodeOccur !== occur) && isSpecificType ?
                                    ` ${this.outputBuilder.occur.or(html)} ${this.outputBuilder.parenOpen(html)}` : ` ${this.outputBuilder.occur.or(html)} `;
                            }
                        }
                        // #endregion
                    }

                    outputString += occurString;
                } else {
                    outputString += ' ';
                }
            }
            let preOccurString;
            if ((dialect === AEQueryElements.DRCLASSIC) && (jquery(element).attr(AEQueryElements.occur))) {
                preOccurString = this.parseXMLOccur(element);
                if (preOccurString === AEQueryElements.MUST) {
                    outputString += `${this.outputBuilder.occur.plus(html)}`;
                } else if (preOccurString === AEQueryElements.MUST_NOT) {
                    outputString += `${this.outputBuilder.occur.minus(html)}`;
                }
            } else if (dialect === AEQueryElements.DRSTANDARD && (jquery(element).attr(AEQueryElements.occur))) {
                preOccurString = this.parseXMLOccur(element);
                if (preOccurString === AEQueryElements.MUST_NOT) {
                    outputString += `${this.outputBuilder.occur.not(html)} `;
                }
            }

            const field = jquery(element).attr(AEQueryElements.field);
            if (field) {
                const fieldString = field ? field + (dialect === AEQueryElements.DRCLASSIC ? ':' : '::') : '';
                outputString += this.outputBuilder.fieldStart(fieldString, html);
            }

            if (jquery(element).children().length === 0) {
                // leaf node - no recursion

                switch (jquery(element)[0].nodeName) {
                    case AEQueryElements.text:
                    case AEQueryElements.wildcard: {
                        if (html && cookieFilter === XmlKeys.GADateFiltersCookieKey) {
                            outputString += this.colorize(jquery(element)[0].textContent, false, false);
                        } else {
                            if (escapeAngleBrackets) {
                                outputString += jquery(element)[0].textContent.replace(/>/g, '&gt;').replace(/</g, '&lt;');
                            } else {
                                outputString += jquery(element)[0].textContent;
                            }
                        }

                        // #region ECASL-27668 - brackets formatting
                        if (aliasNodeFieldName && prevNodeOccur === occur && occur !== nextNodeOccur && nextNodeOccur && isSpecificType && !isFirst) {
                            outputString += this.outputBuilder.parenClose(html);
                        } else {
                            aliasNodeFieldName = jquery(element).attr(AEQueryElements.aliasname);
                            outputString += isSpecificType && (nextChildNode && (nextNodeField !== field || nextNodeOccur !== occur)) ?
                                (aliasNodeFieldName && !nextNodeAliasField) ? '' : this.outputBuilder.parenClose(html) : '';
                        }
                        // #endregion
                        break;
                    }
                    case AEQueryElements.fuzzy:
                    case AEQueryElements.phrase_sloppy: {
                        const slop = jquery(element).attr(AEQueryElements.slop);
                        let slopString = '';
                        if (slop) {
                            slopString = isNaN(parseInt(slop, 10)) ? '' : '~' + slop;
                        }
                        outputString += jquery(element)[0].textContent + slopString;
                        break;
                    }
                    case AEQueryElements.phrase_proximity: {
                        const phraseOrderStr = this.parseXMLOrder(element) ? '~o' : '~u';
                        const phraseDistanceStr = this.parseXMLDistance(element);

                        outputString += jquery(element)[0].textContent + phraseOrderStr + phraseDistanceStr;
                        break;
                    }
                    case AEQueryElements.regex: {
                        outputString += (dialect === AEQueryElements.DRCLASSIC ? '/r:' : '##') + jquery(element)[0].textContent;
                        break;
                    }

                }
            } else {

                switch (jquery(element)[0].nodeName) {
                    case AEQueryElements.range: {
                        const rangeType = this.parseXMLRange(element);
                        let begin, end;
                        _.each(jquery(element).children(), (innerElem) => {
                            switch (innerElem.nodeName) {
                                case AEQueryElements.begin: {
                                    begin = innerElem.textContent;
                                    break;
                                }
                                case AEQueryElements.end: {
                                    end = innerElem.textContent;
                                    break;
                                }
                                default:
                                    {
                                        console.error('Ignoring unexpected element in range');
                                        console.error(innerElem);
                                    }
                            }
                        });
                        outputString += (rangeType === AEQueryElements.inclusive || rangeType === AEQueryElements.inclusive_exclusive) ? '[' : '{';
                        outputString += begin + ((dialect === AEQueryElements.DRCLASSIC) ? ' TO ' : ' ~~ ') + end;
                        outputString += (rangeType === AEQueryElements.inclusive || rangeType === AEQueryElements.exclusive_inclusive) ? ']' : '}';
                        break;
                    }
                    case AEQueryElements.child_of:
                    case AEQueryElements.children_of:
                    case AEQueryElements.family_of:
                    case AEQueryElements.parent_of:
                    case AEQueryElements.root_of:
                    case AEQueryElements.archive_of:
                    case AEQueryElements.nested_archive_of:
                    case AEQueryElements.archive_contents: {
                        outputString += this.outputBuilder.family(jquery(element)[0].nodeName);
                        outputString += this.parseXMLNode(element, jquery(element)[0].nodeName, dialect, false, html, escapeAngleBrackets);
                        break;
                    }
                    case AEQueryElements.clause_non_proximity: {
                        non_proximity = !non_proximity;
                        outputString += this.parseXMLNode(element, jquery(element)[0].nodeName, dialect, non_proximity, html, escapeAngleBrackets);
                        break;
                    }
                    default: {
                        outputString += this.parseXMLNode(element, jquery(element)[0].nodeName, dialect, non_proximity, html, escapeAngleBrackets);
                        break;
                    }
                }
            }
            isFirst = false;
            if (field) {
                outputString += this.outputBuilder.fieldEnd(html);
            }
        });

        // #region ECASL-27668 - brackets formatting
        if (cookieFilter && (cookieFilter === XmlKeys.CustodiansCookieKey ||
            cookieFilter === XmlKeys.FoldersCookieKey) &&
            (type === AEQueryElements.query || type === AEQueryElements.clause_proximity)) {
            outputString += this.outputBuilder.parenClose(html);
            outputString += this.outputBuilder.parenClose(html);
        } else if (type === AEQueryElements.query || (type === AEQueryElements.clause_proximity && distanceString === '0')) {
            outputString += this.outputBuilder.parenClose(html);
        }
        // #endregion

        if (type === AEQueryElements.clause_proximity && dialect === AEQueryElements.DRCLASSIC) {
            outputString += occurString;
        }

        return outputString;
    }

    extractQuery(description: string): string[] {
        let query: string, target: string, metadataPrefix = null;
        query = description.includes('Searching for ') ? description.replace('Searching for ', '') :
            description.replace('Searching ', '');
        if (query.includes('Metadata Bulk Search for ')) {
            metadataPrefix = 'Metadata Bulk Search for ';
            query = query.replace(metadataPrefix, '');
        }
        const index = query.indexOf(' in ');
        if (index !== -1) {
            target = query.substring(index);
            query = query.substring(0, index);
        }

        if (query[0] === '(') {
            let parenDepth = 1;
            let strIndex = 1;
            while ((parenDepth > 0) && (strIndex < query.length - 1)) {
                if (query[strIndex] === '(') {
                    parenDepth++;
                } else if (query[strIndex] === ')') {
                    parenDepth--;
                }
                strIndex++;
            }
        }

        return [query, target, metadataPrefix];
    }

    private escapeRegExp(str: string): string {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    stripExtraneousParens(query: string, leaveOne = false): string {
        const startIndex = leaveOne ? 1 : 0;
        if (query[startIndex] === '(') {
            let parenDepth = 1;
            let strIndex = 1 + startIndex;
            while ((parenDepth > 0) && (strIndex < query.length - (1 + startIndex))) {
                if (query[strIndex] === '(') {
                    parenDepth++;
                } else if (query[strIndex] === ')') {
                    parenDepth--;
                }
                strIndex++;
            }
            if (parenDepth > 0) {
                query = query.substring(1, query.length - 1);
            }
        }
        return query;
    }

    colorize(query: string, embedQuery = true, escapeAngleBrackets = true): string {
        if (isNullOrUndefined(query)) {
            query = '';
        } else {
            if (escapeAngleBrackets) {
                query = query.replace(/</g, '&lt;').replace(/>/g, '&gt;');
            }
        }
        if (query.length > 0 && query.length < 30000) {
            // change &nbsp; to a space
            query = query.replace(/\u00a0/g, ' ');
            query = query + '<span></span>';
            // reg ex with look ahead to ignore a keyword if the count of trailing quotes is odd
            const quoteRegEx = '(?=(?:[^"]*"[^"]*")*[^"]*$)';
            if (this.commonService.searchDialect === SearchDialect.DR_CLASSIC) {
                query = query.replace(new RegExp('\\+\\(' + quoteRegEx, 'g'), (this.outputBuilder.occur.plus(true) + '('));
                query = query.replace(new RegExp('\\-\\(' + quoteRegEx, 'g'), (this.outputBuilder.occur.minus(true) + '('));
            } else {
                query = query.replace(new RegExp('\\b(OR|or)\\b' + quoteRegEx, 'g'), (match) => {
                    return match === 'OR' ? this.outputBuilder.occur.or(true) : this.outputBuilder.occur.or(true).toLowerCase();
                });
                query = query.replace(new RegExp('\\b(AND|and)\\b' + quoteRegEx, 'g'), (match) => {
                    return match === 'AND' ? this.outputBuilder.occur.and(true) : this.outputBuilder.occur.and(true).toLowerCase();
                });
                query = query.replace(new RegExp('\\b(NOT|not)\\b' + quoteRegEx, 'g'), (match) => {
                    return match === 'NOT' ? this.outputBuilder.occur.not(true) : this.outputBuilder.occur.not(true).toLowerCase();
                });
            }
            query = query.replace(/\(/g, this.outputBuilder.parenOpen(true));
            query = query.replace(/\)/g, this.outputBuilder.parenClose(true));

            familyKeywords.forEach((key: AEQueryElements | string) => {
                query = query.replace(new RegExp(`\\b(${this.escapeRegExp(key)})`, 'g'), this.outputBuilder.family(key, true));
            });

            const metaPostfix = this.commonService.searchDialect === SearchDialect.DR_CLASSIC ? ':' : '::';
            metadata.forEach((key: string) => {
                const regEx = new RegExp(`\\b(${this.escapeRegExp(key + metaPostfix)}(.|\\s)*?<span)`, 'g');
                query = query.replace(regEx, (match) => {
                    const matchWithoutPrefix = match.replace(key + metaPostfix, '');
                    const trail = matchWithoutPrefix.substring(0, matchWithoutPrefix.indexOf('<span'));
                    const trimmedTrail = trail.trim();
                    return this.outputBuilder.fieldStart(key + metaPostfix, true) + trimmedTrail + this.outputBuilder.fieldEnd(true) +
                        (trail.length > trimmedTrail.length ? ' ' : '') + '<span';
                });
            });

            query = this.replaceWithEscapeChar(query);
            query = query.substring(0, query.length - 13);
            if (embedQuery) {
                query = '<span>' + query + '</span>';
            }
        }
        return query;
    }

    replaceWithEscapeChar(text: string, reverseReplacement = false): string {
        let regex, replaceString = text, replacementString;
        if (reverseReplacement) {
            regex = new RegExp(ExistsTag.WithEscapeChar, 'g');
            replacementString = ExistsTag.WithoutEscapeChar;

        } else {
            regex = new RegExp(ExistsTag.WithoutEscapeChar, 'g');
            replacementString = ExistsTag.WithEscapeChar;
        }
        replaceString = replaceString.replace(regex, replacementString);
        return replaceString;
    }
}
